const THREE = require("three");
function f1469() {
  throw new Error("BufferGeometryUtils: computeTangents renamed to computeMikkTSpaceTangents.");
}
function f1470(p11665, p11666, p11667 = true) {
  if (!p11666 || !p11666.isReady) {
    throw new Error("BufferGeometryUtils: Initialized MikkTSpace library required.");
  }
  if (!p11665.hasAttribute("position") || !p11665.hasAttribute("normal") || !p11665.hasAttribute("uv")) {
    throw new Error("BufferGeometryUtils: Tangents require \"position\", \"normal\", and \"uv\" attributes.");
  }
  function f1471(p11668) {
    if (p11668.normalized || p11668.isInterleavedBufferAttribute) {
      const v8787 = new Float32Array(p11668.getCount() * p11668.itemSize);
      for (let vLN01435 = 0, vLN01436 = 0; vLN01435 < p11668.getCount(); vLN01435++) {
        v8787[vLN01436++] = p11668.getX(vLN01435);
        v8787[vLN01436++] = p11668.getY(vLN01435);
        if (p11668.itemSize > 2) {
          v8787[vLN01436++] = p11668.getZ(vLN01435);
        }
      }
      return v8787;
    }
    if (p11668.array instanceof Float32Array) {
      return p11668.array;
    }
    return new Float32Array(p11668.array);
  }
  const v8788 = p11665.index ? p11665.toNonIndexed() : p11665;
  const v8789 = p11666.generateTangents(f1471(v8788.attributes.position), f1471(v8788.attributes.normal), f1471(v8788.attributes.uv));
  if (p11667) {
    for (let vLN312 = 3; vLN312 < v8789.length; vLN312 += 4) {
      v8789[vLN312] *= -1;
    }
  }
  v8788.setAttribute("tangent", new THREE.BufferAttribute(v8789, 4));
  if (p11665 !== v8788) {
    p11665.copy(v8788);
  }
  return p11665;
}
function f1472(p11669, p11670 = false) {
  const v8790 = p11669[0].index !== null;
  const v8791 = new Set(Object.keys(p11669[0].attributes));
  const v8792 = new Set(Object.keys(p11669[0].morphAttributes));
  const vO271 = {};
  const vO272 = {};
  const v8793 = p11669[0].morphTargetsRelative;
  const v8794 = new THREE.BufferGeometry();
  let vLN01437 = 0;
  for (let vLN01438 = 0; vLN01438 < p11669.length; ++vLN01438) {
    const v8795 = p11669[vLN01438];
    let vLN01439 = 0;
    if (v8790 !== (v8795.index !== null)) {
      console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + vLN01438 + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
      return null;
    }
    for (const v8796 in v8795.attributes) {
      if (!v8791.has(v8796)) {
        console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + vLN01438 + ". All geometries must have compatible attributes; make sure \"" + v8796 + "\" attribute exists among all geometries, or in none of them.");
        return null;
      }
      if (vO271[v8796] === undefined) {
        vO271[v8796] = [];
      }
      vO271[v8796].push(v8795.attributes[v8796]);
      vLN01439++;
    }
    if (vLN01439 !== v8791.size) {
      console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + vLN01438 + ". Make sure all geometries have the same number of attributes.");
      return null;
    }
    if (v8793 !== v8795.morphTargetsRelative) {
      console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + vLN01438 + ". .morphTargetsRelative must be consistent throughout all geometries.");
      return null;
    }
    for (const v8797 in v8795.morphAttributes) {
      if (!v8792.has(v8797)) {
        console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + vLN01438 + ".  .morphAttributes must be consistent throughout all geometries.");
        return null;
      }
      if (vO272[v8797] === undefined) {
        vO272[v8797] = [];
      }
      vO272[v8797].push(v8795.morphAttributes[v8797]);
    }
    if (p11670) {
      let v8798;
      if (v8790) {
        v8798 = v8795.index.count;
      } else if (v8795.attributes.position !== undefined) {
        v8798 = v8795.attributes.position.count;
      } else {
        console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + vLN01438 + ". The geometry must have either an index or a position attribute");
        return null;
      }
      v8794.addGroup(vLN01437, v8798, vLN01438);
      vLN01437 += v8798;
    }
  }
  if (v8790) {
    let vLN01440 = 0;
    const vA475 = [];
    for (let vLN01441 = 0; vLN01441 < p11669.length; ++vLN01441) {
      const v8799 = p11669[vLN01441].index;
      for (let vLN01442 = 0; vLN01442 < v8799.count; ++vLN01442) {
        vA475.push(v8799.getX(vLN01442) + vLN01440);
      }
      vLN01440 += p11669[vLN01441].attributes.position.count;
    }
    v8794.setIndex(vA475);
  }
  for (const v8800 in vO271) {
    const vIi33 = f1473(vO271[v8800]);
    if (!vIi33) {
      console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + v8800 + " attribute.");
      return null;
    }
    v8794.setAttribute(v8800, vIi33);
  }
  for (const v8801 in vO272) {
    const v8802 = vO272[v8801][0].length;
    if (v8802 === 0) {
      break;
    }
    v8794.morphAttributes = v8794.morphAttributes || {};
    v8794.morphAttributes[v8801] = [];
    for (let vLN01443 = 0; vLN01443 < v8802; ++vLN01443) {
      const vA476 = [];
      for (let vLN01444 = 0; vLN01444 < vO272[v8801].length; ++vLN01444) {
        vA476.push(vO272[v8801][vLN01444][vLN01443]);
      }
      const vIi34 = f1473(vA476);
      if (!vIi34) {
        console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + v8801 + " morphAttribute.");
        return null;
      }
      v8794.morphAttributes[v8801].push(vIi34);
    }
  }
  return v8794;
}
function f1473(p11671) {
  let v8803;
  let v8804;
  let v8805;
  let vLN01445 = 0;
  for (let vLN01446 = 0; vLN01446 < p11671.length; ++vLN01446) {
    const v8806 = p11671[vLN01446];
    if (v8806.isInterleavedBufferAttribute) {
      console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. InterleavedBufferAttributes are not supported.");
      return null;
    }
    if (v8803 === undefined) {
      v8803 = v8806.array.constructor;
    }
    if (v8803 !== v8806.array.constructor) {
      console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.");
      return null;
    }
    if (v8804 === undefined) {
      v8804 = v8806.itemSize;
    }
    if (v8804 !== v8806.itemSize) {
      console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.");
      return null;
    }
    if (v8805 === undefined) {
      v8805 = v8806.normalized;
    }
    if (v8805 !== v8806.normalized) {
      console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.");
      return null;
    }
    vLN01445 += v8806.array.length;
  }
  const v8807 = new v8803(vLN01445);
  let vLN01447 = 0;
  for (let vLN01448 = 0; vLN01448 < p11671.length; ++vLN01448) {
    v8807.set(p11671[vLN01448].array, vLN01447);
    vLN01447 += p11671[vLN01448].array.length;
  }
  return new THREE.BufferAttribute(v8807, v8804, v8805);
}
function f1474(p11672) {
  if (p11672.isInstancedInterleavedBufferAttribute || p11672.isInterleavedBufferAttribute) {
    return f1476(p11672);
  }
  if (p11672.isInstancedBufferAttribute) {
    return new THREE.InstancedBufferAttribute().copy(p11672);
  }
  return new THREE.BufferAttribute().copy(p11672);
}
function f1475(p11673) {
  let v8808;
  let vLN01449 = 0;
  let vLN01450 = 0;
  for (let vLN01451 = 0, v8809 = p11673.length; vLN01451 < v8809; ++vLN01451) {
    const v8810 = p11673[vLN01451];
    if (v8808 === undefined) {
      v8808 = v8810.array.constructor;
    }
    if (v8808 !== v8810.array.constructor) {
      console.error("AttributeBuffers of different types cannot be interleaved");
      return null;
    }
    vLN01449 += v8810.array.length;
    vLN01450 += v8810.itemSize;
  }
  const v8811 = new THREE.InterleavedBuffer(new v8808(vLN01449), vLN01450);
  let vLN01452 = 0;
  const vA477 = [];
  const vA478 = ["getX", "getY", "getZ", "getW"];
  const vA479 = ["setX", "setY", "setZ", "setW"];
  for (let vLN01453 = 0, v8812 = p11673.length; vLN01453 < v8812; vLN01453++) {
    const v8813 = p11673[vLN01453];
    const v8814 = v8813.itemSize;
    const v8815 = v8813.count;
    const v8816 = new THREE.InterleavedBufferAttribute(v8811, v8814, vLN01452, v8813.normalized);
    vA477.push(v8816);
    vLN01452 += v8814;
    for (let vLN01454 = 0; vLN01454 < v8815; vLN01454++) {
      for (let vLN01455 = 0; vLN01455 < v8814; vLN01455++) {
        v8816[vA479[vLN01455]](vLN01454, v8813[vA478[vLN01455]](vLN01454));
      }
    }
  }
  return vA477;
}
function f1476(p11674) {
  const v8817 = p11674.data.array.constructor;
  const v8818 = p11674.count;
  const v8819 = p11674.itemSize;
  const v8820 = p11674.normalized;
  const v8821 = new v8817(v8818 * v8819);
  let v8822;
  if (p11674.isInstancedInterleavedBufferAttribute) {
    v8822 = new THREE.InstancedBufferAttribute(v8821, v8819, v8820, p11674.meshPerAttribute);
  } else {
    v8822 = new THREE.BufferAttribute(v8821, v8819, v8820);
  }
  for (let vLN01456 = 0; vLN01456 < v8818; vLN01456++) {
    v8822.setX(vLN01456, p11674.getX(vLN01456));
    if (v8819 >= 2) {
      v8822.setY(vLN01456, p11674.getY(vLN01456));
    }
    if (v8819 >= 3) {
      v8822.setZ(vLN01456, p11674.getZ(vLN01456));
    }
    if (v8819 >= 4) {
      v8822.setW(vLN01456, p11674.getW(vLN01456));
    }
  }
  return v8822;
}
function f1477(p11675) {
  const v8823 = p11675.attributes;
  const v8824 = p11675.morphTargets;
  const v8825 = new Map();
  for (const v8826 in v8823) {
    const v8827 = v8823[v8826];
    if (v8827.isInterleavedBufferAttribute) {
      if (!v8825.has(v8827)) {
        v8825.set(v8827, f1476(v8827));
      }
      v8823[v8826] = v8825.get(v8827);
    }
  }
  for (const v8828 in v8824) {
    const v8829 = v8824[v8828];
    if (v8829.isInterleavedBufferAttribute) {
      if (!v8825.has(v8829)) {
        v8825.set(v8829, f1476(v8829));
      }
      v8824[v8828] = v8825.get(v8829);
    }
  }
}
function f1478(p11676) {
  let vLN01457 = 0;
  for (const v8830 in p11676.attributes) {
    const v8831 = p11676.getAttribute(v8830);
    vLN01457 += v8831.count * v8831.itemSize * v8831.array.BYTES_PER_ELEMENT;
  }
  const v8832 = p11676.getIndex();
  vLN01457 += v8832 ? v8832.count * v8832.itemSize * v8832.array.BYTES_PER_ELEMENT : 0;
  return vLN01457;
}
function f1479(p11677, p11678 = 0.0001) {
  p11678 = Math.max(p11678, Number.EPSILON);
  const vO273 = {};
  const v8833 = p11677.getIndex();
  const v8834 = p11677.getAttribute("position");
  const v8835 = v8833 ? v8833.count : v8834.count;
  let vLN01458 = 0;
  const v8836 = Object.keys(p11677.attributes);
  const vO274 = {};
  const vO275 = {};
  const vA480 = [];
  const vA481 = ["getX", "getY", "getZ", "getW"];
  const vA482 = ["setX", "setY", "setZ", "setW"];
  for (let vLN01459 = 0, v8837 = v8836.length; vLN01459 < v8837; vLN01459++) {
    const v8838 = v8836[vLN01459];
    const v8839 = p11677.attributes[v8838];
    vO274[v8838] = new THREE.BufferAttribute(new v8839.array.constructor(v8839.count * v8839.itemSize), v8839.itemSize, v8839.normalized);
    const v8840 = p11677.morphAttributes[v8838];
    if (v8840) {
      vO275[v8838] = new THREE.BufferAttribute(new v8840.array.constructor(v8840.count * v8840.itemSize), v8840.itemSize, v8840.normalized);
    }
  }
  const v8841 = Math.log10(1 / p11678);
  const v8842 = Math.pow(10, v8841);
  for (let vLN01460 = 0; vLN01460 < v8835; vLN01460++) {
    const v8843 = v8833 ? v8833.getX(vLN01460) : vLN01460;
    let vLS35 = "";
    for (let vLN01461 = 0, v8844 = v8836.length; vLN01461 < v8844; vLN01461++) {
      const v8845 = v8836[vLN01461];
      const v8846 = p11677.getAttribute(v8845);
      const v8847 = v8846.itemSize;
      for (let vLN01462 = 0; vLN01462 < v8847; vLN01462++) {
        vLS35 += ~~(v8846[vA481[vLN01462]](v8843) * v8842) + ",";
      }
    }
    if (vLS35 in vO273) {
      vA480.push(vO273[vLS35]);
    } else {
      for (let vLN01463 = 0, v8848 = v8836.length; vLN01463 < v8848; vLN01463++) {
        const v8849 = v8836[vLN01463];
        const v8850 = p11677.getAttribute(v8849);
        const v8851 = p11677.morphAttributes[v8849];
        const v8852 = v8850.itemSize;
        const v8853 = vO274[v8849];
        const v8854 = vO275[v8849];
        for (let vLN01464 = 0; vLN01464 < v8852; vLN01464++) {
          const v8855 = vA481[vLN01464];
          const v8856 = vA482[vLN01464];
          v8853[v8856](vLN01458, v8850[v8855](v8843));
          if (v8851) {
            for (let vLN01465 = 0, v8857 = v8851.length; vLN01465 < v8857; vLN01465++) {
              v8854[vLN01465][v8856](vLN01458, v8851[vLN01465][v8855](v8843));
            }
          }
        }
      }
      vO273[vLS35] = vLN01458;
      vA480.push(vLN01458);
      vLN01458++;
    }
  }
  const v8858 = p11677.clone();
  for (const v8859 in p11677.attributes) {
    const v8860 = vO274[v8859];
    v8858.setAttribute(v8859, new THREE.BufferAttribute(v8860.array.slice(0, vLN01458 * v8860.itemSize), v8860.itemSize, v8860.normalized));
    if (!(v8859 in vO275)) {
      continue;
    }
    for (let vLN01466 = 0; vLN01466 < vO275[v8859].length; vLN01466++) {
      const v8861 = vO275[v8859][vLN01466];
      v8858.morphAttributes[v8859][vLN01466] = new THREE.BufferAttribute(v8861.array.slice(0, vLN01458 * v8861.itemSize), v8861.itemSize, v8861.normalized);
    }
  }
  v8858.setIndex(vA480);
  return v8858;
}
function f1480(p11679, p11680) {
  if (p11680 === THREE.TrianglesDrawMode) {
    console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
    return p11679;
  }
  if (p11680 === THREE.TriangleFanDrawMode || p11680 === THREE.TriangleStripDrawMode) {
    let v8862 = p11679.getIndex();
    if (v8862 === null) {
      const vA483 = [];
      const v8863 = p11679.getAttribute("position");
      if (v8863 !== undefined) {
        for (let vLN01467 = 0; vLN01467 < v8863.count; vLN01467++) {
          vA483.push(vLN01467);
        }
        p11679.setIndex(vA483);
        v8862 = p11679.getIndex();
      } else {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
        return p11679;
      }
    }
    const v8864 = v8862.count - 2;
    const vA484 = [];
    if (p11680 === THREE.TriangleFanDrawMode) {
      for (let vLN1137 = 1; vLN1137 <= v8864; vLN1137++) {
        vA484.push(v8862.getX(0));
        vA484.push(v8862.getX(vLN1137));
        vA484.push(v8862.getX(vLN1137 + 1));
      }
    } else {
      for (let vLN01468 = 0; vLN01468 < v8864; vLN01468++) {
        if (vLN01468 % 2 === 0) {
          vA484.push(v8862.getX(vLN01468));
          vA484.push(v8862.getX(vLN01468 + 1));
          vA484.push(v8862.getX(vLN01468 + 2));
        } else {
          vA484.push(v8862.getX(vLN01468 + 2));
          vA484.push(v8862.getX(vLN01468 + 1));
          vA484.push(v8862.getX(vLN01468));
        }
      }
    }
    if (vA484.length / 3 !== v8864) {
      console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
    }
    const v8865 = p11679.clone();
    v8865.setIndex(vA484);
    v8865.clearGroups();
    return v8865;
  } else {
    console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", p11680);
    return p11679;
  }
}
function f1481(p11681) {
  const v8866 = new THREE.Vector3();
  const v8867 = new THREE.Vector3();
  const v8868 = new THREE.Vector3();
  const v8869 = new THREE.Vector3();
  const v8870 = new THREE.Vector3();
  const v8871 = new THREE.Vector3();
  const v8872 = new THREE.Vector3();
  const v8873 = new THREE.Vector3();
  const v8874 = new THREE.Vector3();
  function f1482(p11682, p11683, p11684, p11685, p11686, p11687, p11688, p11689) {
    v8866.fromBufferAttribute(p11683, p11686);
    v8867.fromBufferAttribute(p11683, p11687);
    v8868.fromBufferAttribute(p11683, p11688);
    const v8875 = p11682.morphTargetInfluences;
    if (p11684 && v8875) {
      v8872.set(0, 0, 0);
      v8873.set(0, 0, 0);
      v8874.set(0, 0, 0);
      for (let vLN01469 = 0, v8876 = p11684.length; vLN01469 < v8876; vLN01469++) {
        const v8877 = v8875[vLN01469];
        const v8878 = p11684[vLN01469];
        if (v8877 === 0) {
          continue;
        }
        v8869.fromBufferAttribute(v8878, p11686);
        v8870.fromBufferAttribute(v8878, p11687);
        v8871.fromBufferAttribute(v8878, p11688);
        if (p11685) {
          v8872.addScaledVector(v8869, v8877);
          v8873.addScaledVector(v8870, v8877);
          v8874.addScaledVector(v8871, v8877);
        } else {
          v8872.addScaledVector(v8869.sub(v8866), v8877);
          v8873.addScaledVector(v8870.sub(v8867), v8877);
          v8874.addScaledVector(v8871.sub(v8868), v8877);
        }
      }
      v8866.add(v8872);
      v8867.add(v8873);
      v8868.add(v8874);
    }
    if (p11682.isSkinnedMesh) {
      p11682.boneTransform(p11686, v8866);
      p11682.boneTransform(p11687, v8867);
      p11682.boneTransform(p11688, v8868);
    }
    p11689[p11686 * 3 + 0] = v8866.x;
    p11689[p11686 * 3 + 1] = v8866.y;
    p11689[p11686 * 3 + 2] = v8866.z;
    p11689[p11687 * 3 + 0] = v8867.x;
    p11689[p11687 * 3 + 1] = v8867.y;
    p11689[p11687 * 3 + 2] = v8867.z;
    p11689[p11688 * 3 + 0] = v8868.x;
    p11689[p11688 * 3 + 1] = v8868.y;
    p11689[p11688 * 3 + 2] = v8868.z;
  }
  const v8879 = p11681.geometry;
  const v8880 = p11681.material;
  let v8881;
  let v8882;
  let v8883;
  const v8884 = v8879.index;
  const v8885 = v8879.attributes.position;
  const v8886 = v8879.morphAttributes.position;
  const v8887 = v8879.morphTargetsRelative;
  const v8888 = v8879.attributes.normal;
  const v8889 = v8879.morphAttributes.position;
  const v8890 = v8879.groups;
  const v8891 = v8879.drawRange;
  let v8892;
  let v8893;
  let v8894;
  let v8895;
  let v8896;
  let v8897;
  let v8898;
  const v8899 = new Float32Array(v8885.count * v8885.itemSize);
  const v8900 = new Float32Array(v8888.count * v8888.itemSize);
  if (v8884 !== null) {
    if (Array.isArray(v8880)) {
      v8892 = 0;
      v8894 = v8890.length;
      v8892 = 0;
      v8894 = v8890.length;
      for (; v8892 < v8894; v8892++) {
        v8896 = v8890[v8892];
        v8897 = Math.max(v8896.start, v8891.start);
        v8898 = Math.min(v8896.start + v8896.count, v8891.start + v8891.count);
        v8893 = v8897;
        v8895 = v8898;
        for (; v8893 < v8895; v8893 += 3) {
          v8881 = v8884.getX(v8893);
          v8882 = v8884.getX(v8893 + 1);
          v8883 = v8884.getX(v8893 + 2);
          f1482(p11681, v8885, v8886, v8887, v8881, v8882, v8883, v8899);
          f1482(p11681, v8888, v8889, v8887, v8881, v8882, v8883, v8900);
        }
      }
    } else {
      v8897 = Math.max(0, v8891.start);
      v8898 = Math.min(v8884.count, v8891.start + v8891.count);
      v8892 = v8897;
      v8894 = v8898;
      for (; v8892 < v8894; v8892 += 3) {
        v8881 = v8884.getX(v8892);
        v8882 = v8884.getX(v8892 + 1);
        v8883 = v8884.getX(v8892 + 2);
        f1482(p11681, v8885, v8886, v8887, v8881, v8882, v8883, v8899);
        f1482(p11681, v8888, v8889, v8887, v8881, v8882, v8883, v8900);
      }
    }
  } else if (Array.isArray(v8880)) {
    v8892 = 0;
    v8894 = v8890.length;
    v8892 = 0;
    v8894 = v8890.length;
    for (; v8892 < v8894; v8892++) {
      v8896 = v8890[v8892];
      v8897 = Math.max(v8896.start, v8891.start);
      v8898 = Math.min(v8896.start + v8896.count, v8891.start + v8891.count);
      v8893 = v8897;
      v8895 = v8898;
      for (; v8893 < v8895; v8893 += 3) {
        v8881 = v8893;
        v8882 = v8893 + 1;
        v8883 = v8893 + 2;
        f1482(p11681, v8885, v8886, v8887, v8881, v8882, v8883, v8899);
        f1482(p11681, v8888, v8889, v8887, v8881, v8882, v8883, v8900);
      }
    }
  } else {
    v8897 = Math.max(0, v8891.start);
    v8898 = Math.min(v8885.count, v8891.start + v8891.count);
    v8892 = v8897;
    v8894 = v8898;
    for (; v8892 < v8894; v8892 += 3) {
      v8881 = v8892;
      v8882 = v8892 + 1;
      v8883 = v8892 + 2;
      f1482(p11681, v8885, v8886, v8887, v8881, v8882, v8883, v8899);
      f1482(p11681, v8888, v8889, v8887, v8881, v8882, v8883, v8900);
    }
  }
  const v8901 = new THREE.Float32BufferAttribute(v8899, 3);
  const v8902 = new THREE.Float32BufferAttribute(v8900, 3);
  return {
    positionAttribute: v8885,
    normalAttribute: v8888,
    morphedPositionAttribute: v8901,
    morphedNormalAttribute: v8902
  };
}
function f1483(p11690) {
  if (p11690.groups.length === 0) {
    console.warn("THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.");
    return p11690;
  }
  let v8903 = p11690.groups;
  v8903 = v8903.sort((p11691, p11692) => {
    if (p11691.materialIndex !== p11692.materialIndex) {
      return p11691.materialIndex - p11692.materialIndex;
    }
    return p11691.start - p11692.start;
  });
  if (p11690.getIndex() === null) {
    const v8904 = p11690.getAttribute("position");
    const vA485 = [];
    for (let vLN01470 = 0; vLN01470 < v8904.count; vLN01470 += 3) {
      vA485.push(vLN01470, vLN01470 + 1, vLN01470 + 2);
    }
    p11690.setIndex(vA485);
  }
  const v8905 = p11690.getIndex();
  const vA486 = [];
  for (let vLN01471 = 0; vLN01471 < v8903.length; vLN01471++) {
    const v8906 = v8903[vLN01471];
    const v8907 = v8906.start;
    const v8908 = v8907 + v8906.count;
    for (let vV8907 = v8907; vV8907 < v8908; vV8907++) {
      vA486.push(v8905.getX(vV8907));
    }
  }
  p11690.dispose();
  p11690.setIndex(vA486);
  let vLN01472 = 0;
  for (let vLN01473 = 0; vLN01473 < v8903.length; vLN01473++) {
    const v8909 = v8903[vLN01473];
    v8909.start = vLN01472;
    vLN01472 += v8909.count;
  }
  let v8910 = v8903[0];
  p11690.groups = [v8910];
  for (let vLN1138 = 1; vLN1138 < v8903.length; vLN1138++) {
    const v8911 = v8903[vLN1138];
    if (v8910.materialIndex === v8911.materialIndex) {
      v8910.count += v8911.count;
    } else {
      v8910 = v8911;
      p11690.groups.push(v8910);
    }
  }
  return p11690;
}
function f1484(p11693, p11694 = Math.PI / 3) {
  const v8912 = Math.cos(p11694);
  const vLN10000000001000001 = 100.00000001000001;
  const vA487 = [new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3()];
  const v8913 = new THREE.Vector3();
  const v8914 = new THREE.Vector3();
  const v8915 = new THREE.Vector3();
  const v8916 = new THREE.Vector3();
  function f1485(p11695) {
    const v8917 = ~~(p11695.x * vLN10000000001000001);
    const v8918 = ~~(p11695.y * vLN10000000001000001);
    const v8919 = ~~(p11695.z * vLN10000000001000001);
    return v8917 + "," + v8918 + "," + v8919;
  }
  const v8920 = p11693.toNonIndexed();
  const v8921 = v8920.attributes.position;
  const vO276 = {};
  for (let vLN01474 = 0, v8922 = v8921.count / 3; vLN01474 < v8922; vLN01474++) {
    const v8923 = vLN01474 * 3;
    const v8924 = vA487[0].fromBufferAttribute(v8921, v8923 + 0);
    const v8925 = vA487[1].fromBufferAttribute(v8921, v8923 + 1);
    const v8926 = vA487[2].fromBufferAttribute(v8921, v8923 + 2);
    v8913.subVectors(v8926, v8925);
    v8914.subVectors(v8924, v8925);
    const v8927 = new THREE.Vector3().crossVectors(v8913, v8914).normalize();
    for (let vLN01475 = 0; vLN01475 < 3; vLN01475++) {
      const v8928 = vA487[vLN01475];
      const vF1485 = f1485(v8928);
      if (!(vF1485 in vO276)) {
        vO276[vF1485] = [];
      }
      vO276[vF1485].push(v8927);
    }
  }
  const v8929 = new Float32Array(v8921.count * 3);
  const v8930 = new THREE.BufferAttribute(v8929, 3, false);
  for (let vLN01476 = 0, v8931 = v8921.count / 3; vLN01476 < v8931; vLN01476++) {
    const v8932 = vLN01476 * 3;
    const v8933 = vA487[0].fromBufferAttribute(v8921, v8932 + 0);
    const v8934 = vA487[1].fromBufferAttribute(v8921, v8932 + 1);
    const v8935 = vA487[2].fromBufferAttribute(v8921, v8932 + 2);
    v8913.subVectors(v8935, v8934);
    v8914.subVectors(v8933, v8934);
    v8915.crossVectors(v8913, v8914).normalize();
    for (let vLN01477 = 0; vLN01477 < 3; vLN01477++) {
      const v8936 = vA487[vLN01477];
      const vF14852 = f1485(v8936);
      const v8937 = vO276[vF14852];
      v8916.set(0, 0, 0);
      for (let vLN01478 = 0, v8938 = v8937.length; vLN01478 < v8938; vLN01478++) {
        const v8939 = v8937[vLN01478];
        if (v8915.dot(v8939) > v8912) {
          v8916.add(v8939);
        }
      }
      v8916.normalize();
      v8930.setXYZ(v8932 + vLN01477, v8916.x, v8916.y, v8916.z);
    }
  }
  v8920.setAttribute("normal", v8930);
  return v8920;
}
export class GLTFLoader extends THREE.Loader {
  constructor(p11696) {
    super(p11696);
    this.dracoLoader = null;
    this.ktx2Loader = null;
    this.meshoptDecoder = null;
    this.pluginCallbacks = [];
    this.register(function (p11697) {
      return new C259(p11697);
    });
    this.register(function (p11698) {
      return new C266(p11698);
    });
    this.register(function (p11699) {
      return new C267(p11699);
    });
    this.register(function (p11700) {
      return new C268(p11700);
    });
    this.register(function (p11701) {
      return new C261(p11701);
    });
    this.register(function (p11702) {
      return new C262(p11702);
    });
    this.register(function (p11703) {
      return new C263(p11703);
    });
    this.register(function (p11704) {
      return new C264(p11704);
    });
    this.register(function (p11705) {
      return new C258(p11705);
    });
    this.register(function (p11706) {
      return new C265(p11706);
    });
    this.register(function (p11707) {
      return new C260(p11707);
    });
    this.register(function (p11708) {
      return new C256(p11708);
    });
    this.register(function (p11709) {
      return new C269(p11709);
    });
    this.register(function (p11710) {
      return new C270(p11710);
    });
  }
  load(p11711, p11712, p11713, p11714) {
    const vThis78 = this;
    let v8940;
    if (this.resourcePath !== "") {
      v8940 = this.resourcePath;
    } else if (this.path !== "") {
      v8940 = this.path;
    } else {
      v8940 = THREE.LoaderUtils.extractUrlBase(p11711);
    }
    this.manager.itemStart(p11711);
    const vF80 = function (p11715) {
      if (p11714) {
        p11714(p11715);
      } else {
        console.error(p11715);
      }
      vThis78.manager.itemError(p11711);
      vThis78.manager.itemEnd(p11711);
    };
    const v8941 = new THREE.FileLoader(this.manager);
    v8941.setPath(this.path);
    v8941.setResponseType("arraybuffer");
    v8941.setRequestHeader(this.requestHeader);
    v8941.setWithCredentials(this.withCredentials);
    v8941.load(p11711, function (p11716) {
      try {
        vThis78.parse(p11716, v8940, function (p11717) {
          p11712(p11717);
          vThis78.manager.itemEnd(p11711);
        }, vF80);
      } catch (e83) {
        vF80(e83);
      }
    }, p11713, vF80);
  }
  setDRACOLoader(p11718) {
    this.dracoLoader = p11718;
    return this;
  }
  setDDSLoader() {
    throw new Error("THREE.GLTFLoader: \"MSFT_texture_dds\" no longer supported. Please update to \"KHR_texture_basisu\".");
  }
  setKTX2Loader(p11719) {
    this.ktx2Loader = p11719;
    return this;
  }
  setMeshoptDecoder(p11720) {
    this.meshoptDecoder = p11720;
    return this;
  }
  register(p11721) {
    if (this.pluginCallbacks.indexOf(p11721) === -1) {
      this.pluginCallbacks.push(p11721);
    }
    return this;
  }
  unregister(p11722) {
    if (this.pluginCallbacks.indexOf(p11722) !== -1) {
      this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(p11722), 1);
    }
    return this;
  }
  parse(p11723, p11724, p11725, p11726) {
    let v8942;
    const vO277 = {};
    const vO278 = {};
    const v8943 = new TextDecoder();
    if (typeof p11723 === "string") {
      v8942 = JSON.parse(p11723);
    } else if (p11723 instanceof ArrayBuffer) {
      const v8944 = v8943.decode(new Uint8Array(p11723, 0, 4));
      if (v8944 === vLSGlTF) {
        try {
          vO277[vO280.KHR_BINARY_GLTF] = new C271(p11723);
        } catch (e84) {
          if (p11726) {
            p11726(e84);
          }
          return;
        }
        v8942 = JSON.parse(vO277[vO280.KHR_BINARY_GLTF].content);
      } else {
        v8942 = JSON.parse(v8943.decode(p11723));
      }
    } else {
      v8942 = p11723;
    }
    if (v8942.asset === undefined || v8942.asset.version[0] < 2) {
      if (p11726) {
        p11726(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
      }
      return;
    }
    const v8945 = new C277(v8942, {
      path: p11724 || this.resourcePath || "",
      crossOrigin: this.crossOrigin,
      requestHeader: this.requestHeader,
      manager: this.manager,
      ktx2Loader: this.ktx2Loader,
      meshoptDecoder: this.meshoptDecoder
    });
    v8945.fileLoader.setRequestHeader(this.requestHeader);
    for (let vLN01479 = 0; vLN01479 < this.pluginCallbacks.length; vLN01479++) {
      const v8946 = this.pluginCallbacks[vLN01479](v8945);
      vO278[v8946.name] = v8946;
      vO277[v8946.name] = true;
    }
    if (v8942.extensionsUsed) {
      for (let vLN01480 = 0; vLN01480 < v8942.extensionsUsed.length; ++vLN01480) {
        const v8947 = v8942.extensionsUsed[vLN01480];
        const v8948 = v8942.extensionsRequired || [];
        switch (v8947) {
          case vO280.KHR_MATERIALS_UNLIT:
            vO277[v8947] = new C257();
            break;
          case vO280.KHR_DRACO_MESH_COMPRESSION:
            vO277[v8947] = new C272(v8942, this.dracoLoader);
            break;
          case vO280.KHR_TEXTURE_TRANSFORM:
            vO277[v8947] = new C273();
            break;
          case vO280.KHR_MESH_QUANTIZATION:
            vO277[v8947] = new C274();
            break;
          default:
            if (v8948.indexOf(v8947) >= 0 && vO278[v8947] === undefined) {
              console.warn("THREE.GLTFLoader: Unknown extension \"" + v8947 + "\".");
            }
        }
      }
    }
    v8945.setExtensions(vO277);
    v8945.setPlugins(vO278);
    v8945.parse(p11725, p11726);
  }
  parseAsync(p11727, p11728) {
    const vThis79 = this;
    return new Promise(function (p11729, p11730) {
      vThis79.parse(p11727, p11728, p11729, p11730);
    });
  }
}
function f1486() {
  let vO279 = {};
  return {
    get: function (p11731) {
      return vO279[p11731];
    },
    add: function (p11732, p11733) {
      vO279[p11732] = p11733;
    },
    remove: function (p11734) {
      delete vO279[p11734];
    },
    removeAll: function () {
      vO279 = {};
    }
  };
}
const vO280 = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_IOR: "KHR_materials_ior",
  KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
  KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_MATERIALS_VOLUME: "KHR_materials_volume",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_TEXTURE_AVIF: "EXT_texture_avif",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
  EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class C256 {
  constructor(p11735) {
    this.parser = p11735;
    this.name = vO280.KHR_LIGHTS_PUNCTUAL;
    this.cache = {
      refs: {},
      uses: {}
    };
  }
  _markDefs() {
    const v8949 = this.parser;
    const v8950 = this.parser.json.nodes || [];
    for (let vLN01481 = 0, v8951 = v8950.length; vLN01481 < v8951; vLN01481++) {
      const v8952 = v8950[vLN01481];
      if (v8952.extensions && v8952.extensions[this.name] && v8952.extensions[this.name].light !== undefined) {
        v8949._addNodeRef(this.cache, v8952.extensions[this.name].light);
      }
    }
  }
  _loadLight(p11736) {
    const v8953 = this.parser;
    const v8954 = "light:" + p11736;
    let v8955 = v8953.cache.get(v8954);
    if (v8955) {
      return v8955;
    }
    const v8956 = v8953.json;
    const v8957 = v8956.extensions && v8956.extensions[this.name] || {};
    const v8958 = v8957.lights || [];
    const v8959 = v8958[p11736];
    let v8960;
    const v8961 = new THREE.Color(16777215);
    if (v8959.color !== undefined) {
      v8961.fromArray(v8959.color);
    }
    const v8962 = v8959.range !== undefined ? v8959.range : 0;
    switch (v8959.type) {
      case "directional":
        v8960 = new THREE.DirectionalLight(v8961);
        v8960.target.position.set(0, 0, -1);
        v8960.add(v8960.target);
        break;
      case "point":
        v8960 = new THREE.PointLight(v8961);
        v8960.distance = v8962;
        break;
      case "spot":
        v8960 = new THREE.SpotLight(v8961);
        v8960.distance = v8962;
        v8959.spot = v8959.spot || {};
        v8959.spot.innerConeAngle = v8959.spot.innerConeAngle !== undefined ? v8959.spot.innerConeAngle : 0;
        v8959.spot.outerConeAngle = v8959.spot.outerConeAngle !== undefined ? v8959.spot.outerConeAngle : Math.PI / 4;
        v8960.angle = v8959.spot.outerConeAngle;
        v8960.penumbra = 1 - v8959.spot.innerConeAngle / v8959.spot.outerConeAngle;
        v8960.target.position.set(0, 0, -1);
        v8960.add(v8960.target);
        break;
      default:
        throw new Error("THREE.GLTFLoader: Unexpected light type: " + v8959.type);
    }
    v8960.position.set(0, 0, 0);
    v8960.decay = 2;
    f1489(v8960, v8959);
    if (v8959.intensity !== undefined) {
      v8960.intensity = v8959.intensity;
    }
    v8960.name = v8953.createUniqueName(v8959.name || "light_" + p11736);
    v8955 = Promise.resolve(v8960);
    v8953.cache.add(v8954, v8955);
    return v8955;
  }
  getDependency(p11737, p11738) {
    if (p11737 !== "light") {
      return;
    }
    return this._loadLight(p11738);
  }
  createNodeAttachment(p11739) {
    const vThis80 = this;
    const v8963 = this.parser;
    const v8964 = v8963.json;
    const v8965 = v8964.nodes[p11739];
    const v8966 = v8965.extensions && v8965.extensions[this.name] || {};
    const v8967 = v8966.light;
    if (v8967 === undefined) {
      return null;
    }
    return this._loadLight(v8967).then(function (p11740) {
      return v8963._getNodeRef(vThis80.cache, v8967, p11740);
    });
  }
}
class C257 {
  constructor() {
    this.name = vO280.KHR_MATERIALS_UNLIT;
  }
  getMaterialType() {
    return THREE.MeshBasicMaterial;
  }
  extendParams(p11741, p11742, p11743) {
    const vA488 = [];
    p11741.color = new THREE.Color(1, 1, 1);
    p11741.opacity = 1;
    const v8968 = p11742.pbrMetallicRoughness;
    if (v8968) {
      if (Array.isArray(v8968.baseColorFactor)) {
        const v8969 = v8968.baseColorFactor;
        p11741.color.fromArray(v8969);
        p11741.opacity = v8969[3];
      }
      if (v8968.baseColorTexture !== undefined) {
        vA488.push(p11743.assignTexture(p11741, "map", v8968.baseColorTexture, THREE.sRGBEncoding));
      }
    }
    return Promise.all(vA488);
  }
}
class C258 {
  constructor(p11744) {
    this.parser = p11744;
    this.name = vO280.KHR_MATERIALS_EMISSIVE_STRENGTH;
  }
  extendMaterialParams(p11745, p11746) {
    const v8970 = this.parser;
    const v8971 = v8970.json.materials[p11745];
    if (!v8971.extensions || !v8971.extensions[this.name]) {
      return Promise.resolve();
    }
    const v8972 = v8971.extensions[this.name].emissiveStrength;
    if (v8972 !== undefined) {
      p11746.emissiveIntensity = v8972;
    }
    return Promise.resolve();
  }
}
class C259 {
  constructor(p11747) {
    this.parser = p11747;
    this.name = vO280.KHR_MATERIALS_CLEARCOAT;
  }
  getMaterialType(p11748) {
    const v8973 = this.parser;
    const v8974 = v8973.json.materials[p11748];
    if (!v8974.extensions || !v8974.extensions[this.name]) {
      return null;
    }
    return THREE.MeshPhysicalMaterial;
  }
  extendMaterialParams(p11749, p11750) {
    const v8975 = this.parser;
    const v8976 = v8975.json.materials[p11749];
    if (!v8976.extensions || !v8976.extensions[this.name]) {
      return Promise.resolve();
    }
    const vA489 = [];
    const v8977 = v8976.extensions[this.name];
    if (v8977.clearcoatFactor !== undefined) {
      p11750.clearcoat = v8977.clearcoatFactor;
    }
    if (v8977.clearcoatTexture !== undefined) {
      vA489.push(v8975.assignTexture(p11750, "clearcoatMap", v8977.clearcoatTexture));
    }
    if (v8977.clearcoatRoughnessFactor !== undefined) {
      p11750.clearcoatRoughness = v8977.clearcoatRoughnessFactor;
    }
    if (v8977.clearcoatRoughnessTexture !== undefined) {
      vA489.push(v8975.assignTexture(p11750, "clearcoatRoughnessMap", v8977.clearcoatRoughnessTexture));
    }
    if (v8977.clearcoatNormalTexture !== undefined) {
      vA489.push(v8975.assignTexture(p11750, "clearcoatNormalMap", v8977.clearcoatNormalTexture));
      if (v8977.clearcoatNormalTexture.scale !== undefined) {
        const v8978 = v8977.clearcoatNormalTexture.scale;
        p11750.clearcoatNormalScale = new THREE.Vector2(v8978, v8978);
      }
    }
    return Promise.all(vA489);
  }
}
class C260 {
  constructor(p11751) {
    this.parser = p11751;
    this.name = vO280.KHR_MATERIALS_IRIDESCENCE;
  }
  getMaterialType(p11752) {
    const v8979 = this.parser;
    const v8980 = v8979.json.materials[p11752];
    if (!v8980.extensions || !v8980.extensions[this.name]) {
      return null;
    }
    return THREE.MeshPhysicalMaterial;
  }
  extendMaterialParams(p11753, p11754) {
    const v8981 = this.parser;
    const v8982 = v8981.json.materials[p11753];
    if (!v8982.extensions || !v8982.extensions[this.name]) {
      return Promise.resolve();
    }
    const vA490 = [];
    const v8983 = v8982.extensions[this.name];
    if (v8983.iridescenceFactor !== undefined) {
      p11754.iridescence = v8983.iridescenceFactor;
    }
    if (v8983.iridescenceTexture !== undefined) {
      vA490.push(v8981.assignTexture(p11754, "iridescenceMap", v8983.iridescenceTexture));
    }
    if (v8983.iridescenceIor !== undefined) {
      p11754.iridescenceIOR = v8983.iridescenceIor;
    }
    if (p11754.iridescenceThicknessRange === undefined) {
      p11754.iridescenceThicknessRange = [100, 400];
    }
    if (v8983.iridescenceThicknessMinimum !== undefined) {
      p11754.iridescenceThicknessRange[0] = v8983.iridescenceThicknessMinimum;
    }
    if (v8983.iridescenceThicknessMaximum !== undefined) {
      p11754.iridescenceThicknessRange[1] = v8983.iridescenceThicknessMaximum;
    }
    if (v8983.iridescenceThicknessTexture !== undefined) {
      vA490.push(v8981.assignTexture(p11754, "iridescenceThicknessMap", v8983.iridescenceThicknessTexture));
    }
    return Promise.all(vA490);
  }
}
class C261 {
  constructor(p11755) {
    this.parser = p11755;
    this.name = vO280.KHR_MATERIALS_SHEEN;
  }
  getMaterialType(p11756) {
    const v8984 = this.parser;
    const v8985 = v8984.json.materials[p11756];
    if (!v8985.extensions || !v8985.extensions[this.name]) {
      return null;
    }
    return THREE.MeshPhysicalMaterial;
  }
  extendMaterialParams(p11757, p11758) {
    const v8986 = this.parser;
    const v8987 = v8986.json.materials[p11757];
    if (!v8987.extensions || !v8987.extensions[this.name]) {
      return Promise.resolve();
    }
    const vA491 = [];
    p11758.sheenColor = new THREE.Color(0, 0, 0);
    p11758.sheenRoughness = 0;
    p11758.sheen = 1;
    const v8988 = v8987.extensions[this.name];
    if (v8988.sheenColorFactor !== undefined) {
      p11758.sheenColor.fromArray(v8988.sheenColorFactor);
    }
    if (v8988.sheenRoughnessFactor !== undefined) {
      p11758.sheenRoughness = v8988.sheenRoughnessFactor;
    }
    if (v8988.sheenColorTexture !== undefined) {
      vA491.push(v8986.assignTexture(p11758, "sheenColorMap", v8988.sheenColorTexture, THREE.sRGBEncoding));
    }
    if (v8988.sheenRoughnessTexture !== undefined) {
      vA491.push(v8986.assignTexture(p11758, "sheenRoughnessMap", v8988.sheenRoughnessTexture));
    }
    return Promise.all(vA491);
  }
}
class C262 {
  constructor(p11759) {
    this.parser = p11759;
    this.name = vO280.KHR_MATERIALS_TRANSMISSION;
  }
  getMaterialType(p11760) {
    const v8989 = this.parser;
    const v8990 = v8989.json.materials[p11760];
    if (!v8990.extensions || !v8990.extensions[this.name]) {
      return null;
    }
    return THREE.MeshPhysicalMaterial;
  }
  extendMaterialParams(p11761, p11762) {
    const v8991 = this.parser;
    const v8992 = v8991.json.materials[p11761];
    if (!v8992.extensions || !v8992.extensions[this.name]) {
      return Promise.resolve();
    }
    const vA492 = [];
    const v8993 = v8992.extensions[this.name];
    if (v8993.transmissionFactor !== undefined) {
      p11762.transmission = v8993.transmissionFactor;
    }
    if (v8993.transmissionTexture !== undefined) {
      vA492.push(v8991.assignTexture(p11762, "transmissionMap", v8993.transmissionTexture));
    }
    return Promise.all(vA492);
  }
}
class C263 {
  constructor(p11763) {
    this.parser = p11763;
    this.name = vO280.KHR_MATERIALS_VOLUME;
  }
  getMaterialType(p11764) {
    const v8994 = this.parser;
    const v8995 = v8994.json.materials[p11764];
    if (!v8995.extensions || !v8995.extensions[this.name]) {
      return null;
    }
    return THREE.MeshPhysicalMaterial;
  }
  extendMaterialParams(p11765, p11766) {
    const v8996 = this.parser;
    const v8997 = v8996.json.materials[p11765];
    if (!v8997.extensions || !v8997.extensions[this.name]) {
      return Promise.resolve();
    }
    const vA493 = [];
    const v8998 = v8997.extensions[this.name];
    p11766.thickness = v8998.thicknessFactor !== undefined ? v8998.thicknessFactor : 0;
    if (v8998.thicknessTexture !== undefined) {
      vA493.push(v8996.assignTexture(p11766, "thicknessMap", v8998.thicknessTexture));
    }
    p11766.attenuationDistance = v8998.attenuationDistance || Infinity;
    const v8999 = v8998.attenuationColor || [1, 1, 1];
    p11766.attenuationColor = new THREE.Color(v8999[0], v8999[1], v8999[2]);
    return Promise.all(vA493);
  }
}
class C264 {
  constructor(p11767) {
    this.parser = p11767;
    this.name = vO280.KHR_MATERIALS_IOR;
  }
  getMaterialType(p11768) {
    const v9000 = this.parser;
    const v9001 = v9000.json.materials[p11768];
    if (!v9001.extensions || !v9001.extensions[this.name]) {
      return null;
    }
    return THREE.MeshPhysicalMaterial;
  }
  extendMaterialParams(p11769, p11770) {
    const v9002 = this.parser;
    const v9003 = v9002.json.materials[p11769];
    if (!v9003.extensions || !v9003.extensions[this.name]) {
      return Promise.resolve();
    }
    const v9004 = v9003.extensions[this.name];
    p11770.ior = v9004.ior !== undefined ? v9004.ior : 1.5;
    return Promise.resolve();
  }
}
class C265 {
  constructor(p11771) {
    this.parser = p11771;
    this.name = vO280.KHR_MATERIALS_SPECULAR;
  }
  getMaterialType(p11772) {
    const v9005 = this.parser;
    const v9006 = v9005.json.materials[p11772];
    if (!v9006.extensions || !v9006.extensions[this.name]) {
      return null;
    }
    return THREE.MeshPhysicalMaterial;
  }
  extendMaterialParams(p11773, p11774) {
    const v9007 = this.parser;
    const v9008 = v9007.json.materials[p11773];
    if (!v9008.extensions || !v9008.extensions[this.name]) {
      return Promise.resolve();
    }
    const vA494 = [];
    const v9009 = v9008.extensions[this.name];
    p11774.specularIntensity = v9009.specularFactor !== undefined ? v9009.specularFactor : 1;
    if (v9009.specularTexture !== undefined) {
      vA494.push(v9007.assignTexture(p11774, "specularIntensityMap", v9009.specularTexture));
    }
    const v9010 = v9009.specularColorFactor || [1, 1, 1];
    p11774.specularColor = new THREE.Color(v9010[0], v9010[1], v9010[2]);
    if (v9009.specularColorTexture !== undefined) {
      vA494.push(v9007.assignTexture(p11774, "specularColorMap", v9009.specularColorTexture, THREE.sRGBEncoding));
    }
    return Promise.all(vA494);
  }
}
class C266 {
  constructor(p11775) {
    this.parser = p11775;
    this.name = vO280.KHR_TEXTURE_BASISU;
  }
  loadTexture(p11776) {
    const v9011 = this.parser;
    const v9012 = v9011.json;
    const v9013 = v9012.textures[p11776];
    if (!v9013.extensions || !v9013.extensions[this.name]) {
      return null;
    }
    const v9014 = v9013.extensions[this.name];
    const v9015 = v9011.options.ktx2Loader;
    if (!v9015) {
      if (v9012.extensionsRequired && v9012.extensionsRequired.indexOf(this.name) >= 0) {
        throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
      } else {
        return null;
      }
    }
    return v9011.loadTextureImage(p11776, v9014.source, v9015);
  }
}
class C267 {
  constructor(p11777) {
    this.parser = p11777;
    this.name = vO280.EXT_TEXTURE_WEBP;
    this.isSupported = null;
  }
  loadTexture(p11778) {
    const v9016 = this.name;
    const v9017 = this.parser;
    const v9018 = v9017.json;
    const v9019 = v9018.textures[p11778];
    if (!v9019.extensions || !v9019.extensions[v9016]) {
      return null;
    }
    const v9020 = v9019.extensions[v9016];
    const v9021 = v9018.images[v9020.source];
    let v9022 = v9017.textureLoader;
    if (v9021.uri) {
      const v9023 = v9017.options.manager.getHandler(v9021.uri);
      if (v9023 !== null) {
        v9022 = v9023;
      }
    }
    return this.detectSupport().then(function (p11779) {
      if (p11779) {
        return v9017.loadTextureImage(p11778, v9020.source, v9022);
      }
      if (v9018.extensionsRequired && v9018.extensionsRequired.indexOf(v9016) >= 0) {
        throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
      }
      return v9017.loadTexture(p11778);
    });
  }
  detectSupport() {
    if (!this.isSupported) {
      this.isSupported = new Promise(function (p11780) {
        const v9024 = new Image();
        v9024.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
        v9024.onload = v9024.onerror = function () {
          p11780(v9024.height === 1);
        };
      });
    }
    return this.isSupported;
  }
}
class C268 {
  constructor(p11781) {
    this.parser = p11781;
    this.name = vO280.EXT_TEXTURE_AVIF;
    this.isSupported = null;
  }
  loadTexture(p11782) {
    const v9025 = this.name;
    const v9026 = this.parser;
    const v9027 = v9026.json;
    const v9028 = v9027.textures[p11782];
    if (!v9028.extensions || !v9028.extensions[v9025]) {
      return null;
    }
    const v9029 = v9028.extensions[v9025];
    const v9030 = v9027.images[v9029.source];
    let v9031 = v9026.textureLoader;
    if (v9030.uri) {
      const v9032 = v9026.options.manager.getHandler(v9030.uri);
      if (v9032 !== null) {
        v9031 = v9032;
      }
    }
    return this.detectSupport().then(function (p11783) {
      if (p11783) {
        return v9026.loadTextureImage(p11782, v9029.source, v9031);
      }
      if (v9027.extensionsRequired && v9027.extensionsRequired.indexOf(v9025) >= 0) {
        throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
      }
      return v9026.loadTexture(p11782);
    });
  }
  detectSupport() {
    if (!this.isSupported) {
      this.isSupported = new Promise(function (p11784) {
        const v9033 = new Image();
        v9033.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=";
        v9033.onload = v9033.onerror = function () {
          p11784(v9033.height === 1);
        };
      });
    }
    return this.isSupported;
  }
}
class C269 {
  constructor(p11785) {
    this.name = vO280.EXT_MESHOPT_COMPRESSION;
    this.parser = p11785;
  }
  loadBufferView(p11786) {
    const v9034 = this.parser.json;
    const v9035 = v9034.bufferViews[p11786];
    if (v9035.extensions && v9035.extensions[this.name]) {
      const v9036 = v9035.extensions[this.name];
      const v9037 = this.parser.getDependency("buffer", v9036.buffer);
      const v9038 = this.parser.options.meshoptDecoder;
      if (!v9038 || !v9038.supported) {
        if (v9034.extensionsRequired && v9034.extensionsRequired.indexOf(this.name) >= 0) {
          throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
        } else {
          return null;
        }
      }
      return v9037.then(function (p11787) {
        const v9039 = v9036.byteOffset || 0;
        const v9040 = v9036.byteLength || 0;
        const v9041 = v9036.count;
        const v9042 = v9036.byteStride;
        const v9043 = new Uint8Array(p11787, v9039, v9040);
        if (v9038.decodeGltfBufferAsync) {
          return v9038.decodeGltfBufferAsync(v9041, v9042, v9043, v9036.mode, v9036.filter).then(function (p11788) {
            return p11788.buffer;
          });
        } else {
          return v9038.ready.then(function () {
            const v9044 = new ArrayBuffer(v9041 * v9042);
            v9038.decodeGltfBuffer(new Uint8Array(v9044), v9041, v9042, v9043, v9036.mode, v9036.filter);
            return v9044;
          });
        }
      });
    } else {
      return null;
    }
  }
}
class C270 {
  constructor(p11789) {
    this.name = vO280.EXT_MESH_GPU_INSTANCING;
    this.parser = p11789;
  }
  createNodeMesh(p11790) {
    const v9045 = this.parser.json;
    const v9046 = v9045.nodes[p11790];
    if (!v9046.extensions || !v9046.extensions[this.name] || v9046.mesh === undefined) {
      return null;
    }
    const v9047 = v9045.meshes[v9046.mesh];
    for (const v9048 of v9047.primitives) {
      if (v9048.mode !== vO286.TRIANGLES && v9048.mode !== vO286.TRIANGLE_STRIP && v9048.mode !== vO286.TRIANGLE_FAN && v9048.mode !== undefined) {
        return null;
      }
    }
    const v9049 = v9046.extensions[this.name];
    const v9050 = v9049.attributes;
    const vA495 = [];
    const vO281 = {};
    for (const v9051 in v9050) {
      vA495.push(this.parser.getDependency("accessor", v9050[v9051]).then(p11791 => {
        vO281[v9051] = p11791;
        return vO281[v9051];
      }));
    }
    if (vA495.length < 1) {
      return null;
    }
    vA495.push(this.parser.createNodeMesh(p11790));
    return Promise.all(vA495).then(p11792 => {
      const v9052 = p11792.pop();
      const v9053 = v9052.isGroup ? v9052.children : [v9052];
      const v9054 = p11792[0].count;
      const vA496 = [];
      for (const v9055 of v9053) {
        const v9056 = new THREE.Matrix4();
        const v9057 = new THREE.Vector3();
        const v9058 = new THREE.Quaternion();
        const v9059 = new THREE.Vector3(1, 1, 1);
        const v9060 = new THREE.InstancedMesh(v9055.geometry, v9055.material, v9054);
        for (let vLN01482 = 0; vLN01482 < v9054; vLN01482++) {
          if (vO281.TRANSLATION) {
            v9057.fromBufferAttribute(vO281.TRANSLATION, vLN01482);
          }
          if (vO281.ROTATION) {
            v9058.fromBufferAttribute(vO281.ROTATION, vLN01482);
          }
          if (vO281.SCALE) {
            v9059.fromBufferAttribute(vO281.SCALE, vLN01482);
          }
          v9060.setMatrixAt(vLN01482, v9056.compose(v9057, v9058, v9059));
        }
        for (const v9061 in vO281) {
          if (v9061 !== "TRANSLATION" && v9061 !== "ROTATION" && v9061 !== "SCALE") {
            v9055.geometry.setAttribute(v9061, vO281[v9061]);
          }
        }
        THREE.Object3D.prototype.copy.call(v9060, v9055);
        v9060.frustumCulled = false;
        this.parser.assignFinalMaterial(v9060);
        vA496.push(v9060);
      }
      if (v9052.isGroup) {
        v9052.clear();
        v9052.add(...vA496);
        return v9052;
      }
      return vA496[0];
    });
  }
}
const vLSGlTF = "glTF";
const vLN1210 = 12;
const vO282 = {
  JSON: 1313821514,
  BIN: 5130562
};
class C271 {
  constructor(p11793) {
    this.name = vO280.KHR_BINARY_GLTF;
    this.content = null;
    this.body = null;
    const v9062 = new DataView(p11793, 0, vLN1210);
    const v9063 = new TextDecoder();
    this.header = {
      magic: v9063.decode(new Uint8Array(p11793.slice(0, 4))),
      version: v9062.getUint32(4, true),
      length: v9062.getUint32(8, true)
    };
    if (this.header.magic !== vLSGlTF) {
      throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
    } else if (this.header.version < 2) {
      throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
    }
    const v9064 = this.header.length - vLN1210;
    const v9065 = new DataView(p11793, vLN1210);
    let vLN01483 = 0;
    while (vLN01483 < v9064) {
      const v9066 = v9065.getUint32(vLN01483, true);
      vLN01483 += 4;
      const v9067 = v9065.getUint32(vLN01483, true);
      vLN01483 += 4;
      if (v9067 === vO282.JSON) {
        const v9068 = new Uint8Array(p11793, vLN1210 + vLN01483, v9066);
        this.content = v9063.decode(v9068);
      } else if (v9067 === vO282.BIN) {
        const v9069 = vLN1210 + vLN01483;
        this.body = p11793.slice(v9069, v9069 + v9066);
      }
      vLN01483 += v9066;
    }
    if (this.content === null) {
      throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
  }
}
class C272 {
  constructor(p11794, p11795) {
    if (!p11795) {
      throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
    }
    this.name = vO280.KHR_DRACO_MESH_COMPRESSION;
    this.json = p11794;
    this.dracoLoader = p11795;
    this.dracoLoader.preload();
  }
  decodePrimitive(p11796, p11797) {
    const v9070 = this.json;
    const v9071 = this.dracoLoader;
    const v9072 = p11796.extensions[this.name].bufferView;
    const v9073 = p11796.extensions[this.name].attributes;
    const vO283 = {};
    const vO284 = {};
    const vO285 = {};
    for (const v9074 in v9073) {
      const v9075 = vO291[v9074] || v9074.toLowerCase();
      vO283[v9075] = v9073[v9074];
    }
    for (const v9076 in p11796.attributes) {
      const v9077 = vO291[v9076] || v9076.toLowerCase();
      if (v9073[v9076] !== undefined) {
        const v9078 = v9070.accessors[p11796.attributes[v9076]];
        const v9079 = vO287[v9078.componentType];
        vO285[v9077] = v9079.name;
        vO284[v9077] = v9078.normalized === true;
      }
    }
    return p11797.getDependency("bufferView", v9072).then(function (p11798) {
      return new Promise(function (p11799) {
        v9071.decodeDracoFile(p11798, function (p11800) {
          for (const v9080 in p11800.attributes) {
            const v9081 = p11800.attributes[v9080];
            const v9082 = vO284[v9080];
            if (v9082 !== undefined) {
              v9081.normalized = v9082;
            }
          }
          p11799(p11800);
        }, vO283, vO285);
      });
    });
  }
}
class C273 {
  constructor() {
    this.name = vO280.KHR_TEXTURE_TRANSFORM;
  }
  extendTexture(p11801, p11802) {
    if (p11802.texCoord !== undefined) {
      console.warn("THREE.GLTFLoader: Custom UV sets in \"" + this.name + "\" extension not yet supported.");
    }
    if (p11802.offset === undefined && p11802.rotation === undefined && p11802.scale === undefined) {
      return p11801;
    }
    p11801 = p11801.clone();
    if (p11802.offset !== undefined) {
      p11801.offset.fromArray(p11802.offset);
    }
    if (p11802.rotation !== undefined) {
      p11801.rotation = p11802.rotation;
    }
    if (p11802.scale !== undefined) {
      p11801.repeat.fromArray(p11802.scale);
    }
    p11801.needsUpdate = true;
    return p11801;
  }
}
class C274 {
  constructor() {
    this.name = vO280.KHR_MESH_QUANTIZATION;
  }
}
class C275 extends THREE.Interpolant {
  constructor(p11803, p11804, p11805, p11806) {
    super(p11803, p11804, p11805, p11806);
  }
  copySampleValue_(p11807) {
    const v9083 = this.resultBuffer;
    const v9084 = this.sampleValues;
    const v9085 = this.valueSize;
    const v9086 = p11807 * v9085 * 3 + v9085;
    for (let vLN01484 = 0; vLN01484 !== v9085; vLN01484++) {
      v9083[vLN01484] = v9084[v9086 + vLN01484];
    }
    return v9083;
  }
  interpolate_(p11808, p11809, p11810, p11811) {
    const v9087 = this.resultBuffer;
    const v9088 = this.sampleValues;
    const v9089 = this.valueSize;
    const v9090 = v9089 * 2;
    const v9091 = v9089 * 3;
    const v9092 = p11811 - p11809;
    const v9093 = (p11810 - p11809) / v9092;
    const v9094 = v9093 * v9093;
    const v9095 = v9094 * v9093;
    const v9096 = p11808 * v9091;
    const v9097 = v9096 - v9091;
    const v9098 = v9095 * -2 + v9094 * 3;
    const v9099 = v9095 - v9094;
    const v9100 = 1 - v9098;
    const v9101 = v9099 - v9094 + v9093;
    for (let vLN01485 = 0; vLN01485 !== v9089; vLN01485++) {
      const v9102 = v9088[v9097 + vLN01485 + v9089];
      const v9103 = v9088[v9097 + vLN01485 + v9090] * v9092;
      const v9104 = v9088[v9096 + vLN01485 + v9089];
      const v9105 = v9088[v9096 + vLN01485] * v9092;
      v9087[vLN01485] = v9100 * v9102 + v9101 * v9103 + v9098 * v9104 + v9099 * v9105;
    }
    return v9087;
  }
}
const v9106 = new THREE.Quaternion();
class C276 extends C275 {
  interpolate_(p11812, p11813, p11814, p11815) {
    const v9107 = super.interpolate_(p11812, p11813, p11814, p11815);
    v9106.fromArray(v9107).normalize().toArray(v9107);
    return v9107;
  }
}
const vO286 = {
  FLOAT: 5126,
  FLOAT_MAT3: 35675,
  FLOAT_MAT4: 35676,
  FLOAT_VEC2: 35664,
  FLOAT_VEC3: 35665,
  FLOAT_VEC4: 35666,
  LINEAR: 9729,
  REPEAT: 10497,
  SAMPLER_2D: 35678,
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6,
  UNSIGNED_BYTE: 5121,
  UNSIGNED_SHORT: 5123
};
const vO287 = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
};
const vO288 = {
  9728: THREE.NearestFilter,
  9729: THREE.LinearFilter,
  9984: THREE.NearestMipmapNearestFilter,
  9985: THREE.LinearMipmapNearestFilter,
  9986: THREE.NearestMipmapLinearFilter,
  9987: THREE.LinearMipmapLinearFilter
};
const vO289 = {
  33071: THREE.ClampToEdgeWrapping,
  33648: THREE.MirroredRepeatWrapping,
  10497: THREE.RepeatWrapping
};
const vO290 = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
const vO291 = {
  POSITION: "position",
  NORMAL: "normal",
  TANGENT: "tangent",
  TEXCOORD_0: "uv",
  TEXCOORD_1: "uv2",
  COLOR_0: "color",
  WEIGHTS_0: "skinWeight",
  JOINTS_0: "skinIndex"
};
const vO292 = {
  scale: "scale",
  translation: "position",
  rotation: "quaternion",
  weights: "morphTargetInfluences"
};
const vO293 = {
  CUBICSPLINE: undefined,
  LINEAR: THREE.InterpolateLinear,
  STEP: THREE.InterpolateDiscrete
};
const vO294 = {
  OPAQUE: "OPAQUE",
  MASK: "MASK",
  BLEND: "BLEND"
};
function f1487(p11816) {
  if (p11816.DefaultMaterial === undefined) {
    p11816.DefaultMaterial = new THREE.MeshStandardMaterial({
      color: 16777215,
      emissive: 0,
      metalness: 1,
      roughness: 1,
      transparent: false,
      depthTest: true,
      side: THREE.FrontSide
    });
  }
  return p11816.DefaultMaterial;
}
function f1488(p11817, p11818, p11819) {
  for (const v9108 in p11819.extensions) {
    if (p11817[v9108] === undefined) {
      p11818.userData.gltfExtensions = p11818.userData.gltfExtensions || {};
      p11818.userData.gltfExtensions[v9108] = p11819.extensions[v9108];
    }
  }
}
function f1489(p11820, p11821) {
  if (p11821.extras !== undefined) {
    if (typeof p11821.extras === "object") {
      Object.assign(p11820.userData, p11821.extras);
    } else {
      console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + p11821.extras);
    }
  }
}
function f1490(p11822, p11823, p11824) {
  let v9109 = false;
  let v9110 = false;
  let v9111 = false;
  for (let vLN01486 = 0, v9112 = p11823.length; vLN01486 < v9112; vLN01486++) {
    const v9113 = p11823[vLN01486];
    if (v9113.POSITION !== undefined) {
      v9109 = true;
    }
    if (v9113.NORMAL !== undefined) {
      v9110 = true;
    }
    if (v9113.COLOR_0 !== undefined) {
      v9111 = true;
    }
    if (v9109 && v9110 && v9111) {
      break;
    }
  }
  if (!v9109 && !v9110 && !v9111) {
    return Promise.resolve(p11822);
  }
  const vA497 = [];
  const vA498 = [];
  const vA499 = [];
  for (let vLN01487 = 0, v9114 = p11823.length; vLN01487 < v9114; vLN01487++) {
    const v9115 = p11823[vLN01487];
    if (v9109) {
      const v9116 = v9115.POSITION !== undefined ? p11824.getDependency("accessor", v9115.POSITION) : p11822.attributes.position;
      vA497.push(v9116);
    }
    if (v9110) {
      const v9117 = v9115.NORMAL !== undefined ? p11824.getDependency("accessor", v9115.NORMAL) : p11822.attributes.normal;
      vA498.push(v9117);
    }
    if (v9111) {
      const v9118 = v9115.COLOR_0 !== undefined ? p11824.getDependency("accessor", v9115.COLOR_0) : p11822.attributes.color;
      vA499.push(v9118);
    }
  }
  return Promise.all([Promise.all(vA497), Promise.all(vA498), Promise.all(vA499)]).then(function (p11825) {
    const v9119 = p11825[0];
    const v9120 = p11825[1];
    const v9121 = p11825[2];
    if (v9109) {
      p11822.morphAttributes.position = v9119;
    }
    if (v9110) {
      p11822.morphAttributes.normal = v9120;
    }
    if (v9111) {
      p11822.morphAttributes.color = v9121;
    }
    p11822.morphTargetsRelative = true;
    return p11822;
  });
}
function f1491(p11826, p11827) {
  p11826.updateMorphTargets();
  if (p11827.weights !== undefined) {
    for (let vLN01488 = 0, v9122 = p11827.weights.length; vLN01488 < v9122; vLN01488++) {
      p11826.morphTargetInfluences[vLN01488] = p11827.weights[vLN01488];
    }
  }
  if (p11827.extras && Array.isArray(p11827.extras.targetNames)) {
    const v9123 = p11827.extras.targetNames;
    if (p11826.morphTargetInfluences.length === v9123.length) {
      p11826.morphTargetDictionary = {};
      for (let vLN01489 = 0, v9124 = v9123.length; vLN01489 < v9124; vLN01489++) {
        p11826.morphTargetDictionary[v9123[vLN01489]] = vLN01489;
      }
    } else {
      console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
  }
}
function f1492(p11828) {
  const v9125 = p11828.extensions && p11828.extensions[vO280.KHR_DRACO_MESH_COMPRESSION];
  let v9126;
  if (v9125) {
    v9126 = "draco:" + v9125.bufferView + ":" + v9125.indices + ":" + f1493(v9125.attributes);
  } else {
    v9126 = p11828.indices + ":" + f1493(p11828.attributes) + ":" + p11828.mode;
  }
  return v9126;
}
function f1493(p11829) {
  let vLS36 = "";
  const v9127 = Object.keys(p11829).sort();
  for (let vLN01490 = 0, v9128 = v9127.length; vLN01490 < v9128; vLN01490++) {
    vLS36 += v9127[vLN01490] + ":" + p11829[v9127[vLN01490]] + ";";
  }
  return vLS36;
}
function f1494(p11830) {
  switch (p11830) {
    case Int8Array:
      return 1 / 127;
    case Uint8Array:
      return 1 / 255;
    case Int16Array:
      return 1 / 32767;
    case Uint16Array:
      return 1 / 65535;
    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
  }
}
function f1495(p11831) {
  if (p11831.search(/\.jpe?g($|\?)/i) > 0 || p11831.search(/^data\:image\/jpeg/) === 0) {
    return "image/jpeg";
  }
  if (p11831.search(/\.webp($|\?)/i) > 0 || p11831.search(/^data\:image\/webp/) === 0) {
    return "image/webp";
  }
  return "image/png";
}
const v9129 = new THREE.Matrix4();
class C277 {
  constructor(p11832 = {}, p11833 = {}) {
    this.json = p11832;
    this.extensions = {};
    this.plugins = {};
    this.options = p11833;
    this.cache = new f1486();
    this.associations = new Map();
    this.primitiveCache = {};
    this.nodeCache = {};
    this.meshCache = {
      refs: {},
      uses: {}
    };
    this.cameraCache = {
      refs: {},
      uses: {}
    };
    this.lightCache = {
      refs: {},
      uses: {}
    };
    this.sourceCache = {};
    this.textureCache = {};
    this.nodeNamesUsed = {};
    let v9130 = false;
    let v9131 = false;
    let v9132 = -1;
    if (typeof navigator !== "undefined") {
      v9130 = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
      v9131 = navigator.userAgent.indexOf("Firefox") > -1;
      v9132 = v9131 ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
    }
    if (typeof createImageBitmap === "undefined" || v9130 || v9131 && v9132 < 98) {
      this.textureLoader = new THREE.TextureLoader(this.options.manager);
    } else {
      this.textureLoader = new THREE.ImageBitmapLoader(this.options.manager);
    }
    this.textureLoader.setCrossOrigin(this.options.crossOrigin);
    this.textureLoader.setRequestHeader(this.options.requestHeader);
    this.fileLoader = new THREE.FileLoader(this.options.manager);
    this.fileLoader.setResponseType("arraybuffer");
    if (this.options.crossOrigin === "use-credentials") {
      this.fileLoader.setWithCredentials(true);
    }
  }
  setExtensions(p11834) {
    this.extensions = p11834;
  }
  setPlugins(p11835) {
    this.plugins = p11835;
  }
  parse(p11836, p11837) {
    const vThis81 = this;
    const v9133 = this.json;
    const v9134 = this.extensions;
    this.cache.removeAll();
    this.nodeCache = {};
    this._invokeAll(function (p11838) {
      return p11838._markDefs && p11838._markDefs();
    });
    Promise.all(this._invokeAll(function (p11839) {
      return p11839.beforeRoot && p11839.beforeRoot();
    })).then(function () {
      return Promise.all([vThis81.getDependencies("scene"), vThis81.getDependencies("animation"), vThis81.getDependencies("camera")]);
    }).then(function (p11840) {
      const vO295 = {
        scene: p11840[0][v9133.scene || 0],
        scenes: p11840[0],
        animations: p11840[1],
        cameras: p11840[2],
        asset: v9133.asset,
        parser: vThis81,
        userData: {}
      };
      f1488(v9134, vO295, v9133);
      f1489(vO295, v9133);
      Promise.all(vThis81._invokeAll(function (p11841) {
        return p11841.afterRoot && p11841.afterRoot(vO295);
      })).then(function () {
        p11836(vO295);
      });
    }).catch(p11837);
  }
  _markDefs() {
    const v9135 = this.json.nodes || [];
    const v9136 = this.json.skins || [];
    const v9137 = this.json.meshes || [];
    for (let vLN01491 = 0, v9138 = v9136.length; vLN01491 < v9138; vLN01491++) {
      const v9139 = v9136[vLN01491].joints;
      for (let vLN01492 = 0, v9140 = v9139.length; vLN01492 < v9140; vLN01492++) {
        v9135[v9139[vLN01492]].isBone = true;
      }
    }
    for (let vLN01493 = 0, v9141 = v9135.length; vLN01493 < v9141; vLN01493++) {
      const v9142 = v9135[vLN01493];
      if (v9142.mesh !== undefined) {
        this._addNodeRef(this.meshCache, v9142.mesh);
        if (v9142.skin !== undefined) {
          v9137[v9142.mesh].isSkinnedMesh = true;
        }
      }
      if (v9142.camera !== undefined) {
        this._addNodeRef(this.cameraCache, v9142.camera);
      }
    }
  }
  _addNodeRef(p11842, p11843) {
    if (p11843 === undefined) {
      return;
    }
    if (p11842.refs[p11843] === undefined) {
      p11842.refs[p11843] = p11842.uses[p11843] = 0;
    }
    p11842.refs[p11843]++;
  }
  _getNodeRef(p11844, p11845, p11846) {
    if (p11844.refs[p11845] <= 1) {
      return p11846;
    }
    const v9143 = p11846.clone();
    const vF81 = (p11847, p11848) => {
      const v9144 = this.associations.get(p11847);
      if (v9144 != null) {
        this.associations.set(p11848, v9144);
      }
      for (const [v9145, v9146] of p11847.children.entries()) {
        vF81(v9146, p11848.children[v9145]);
      }
    };
    vF81(p11846, v9143);
    v9143.name += "_instance_" + p11844.uses[p11845]++;
    return v9143;
  }
  _invokeOne(p11849) {
    const v9147 = Object.values(this.plugins);
    v9147.push(this);
    for (let vLN01494 = 0; vLN01494 < v9147.length; vLN01494++) {
      const vP11849 = p11849(v9147[vLN01494]);
      if (vP11849) {
        return vP11849;
      }
    }
    return null;
  }
  _invokeAll(p11850) {
    const v9148 = Object.values(this.plugins);
    v9148.unshift(this);
    const vA500 = [];
    for (let vLN01495 = 0; vLN01495 < v9148.length; vLN01495++) {
      const vP11850 = p11850(v9148[vLN01495]);
      if (vP11850) {
        vA500.push(vP11850);
      }
    }
    return vA500;
  }
  getDependency(p11851, p11852) {
    const v9149 = p11851 + ":" + p11852;
    let v9150 = this.cache.get(v9149);
    if (!v9150) {
      switch (p11851) {
        case "scene":
          v9150 = this.loadScene(p11852);
          break;
        case "node":
          v9150 = this._invokeOne(function (p11853) {
            return p11853.loadNode && p11853.loadNode(p11852);
          });
          break;
        case "mesh":
          v9150 = this._invokeOne(function (RENDER) {
            return RENDER.loadMesh && RENDER.loadMesh(p11852);
          });
          break;
        case "accessor":
          v9150 = this.loadAccessor(p11852);
          break;
        case "bufferView":
          v9150 = this._invokeOne(function (p11855) {
            return p11855.loadBufferView && p11855.loadBufferView(p11852);
          });
          break;
        case "buffer":
          v9150 = this.loadBuffer(p11852);
          break;
        case "material":
          v9150 = this._invokeOne(function (p11856) {
            return p11856.loadMaterial && p11856.loadMaterial(p11852);
          });
          break;
        case "texture":
          v9150 = this._invokeOne(function (p11857) {
            return p11857.loadTexture && p11857.loadTexture(p11852);
          });
          break;
        case "skin":
          v9150 = this.loadSkin(p11852);
          break;
        case "animation":
          v9150 = this._invokeOne(function (p11858) {
            return p11858.loadAnimation && p11858.loadAnimation(p11852);
          });
          break;
        case "camera":
          v9150 = this.loadCamera(p11852);
          break;
        default:
          v9150 = this._invokeOne(function (p11859) {
            return p11859 != this && p11859.getDependency && p11859.getDependency(p11851, p11852);
          });
          if (!v9150) {
            throw new Error("Unknown type: " + p11851);
          }
          break;
      }
      this.cache.add(v9149, v9150);
    }
    return v9150;
  }
  getDependencies(p11860) {
    let v9151 = this.cache.get(p11860);
    if (!v9151) {
      const vThis82 = this;
      const v9152 = this.json[p11860 + (p11860 === "mesh" ? "es" : "s")] || [];
      v9151 = Promise.all(v9152.map(function (p11861, p11862) {
        return vThis82.getDependency(p11860, p11862);
      }));
      this.cache.add(p11860, v9151);
    }
    return v9151;
  }
  loadBuffer(p11863) {
    const v9153 = this.json.buffers[p11863];
    const v9154 = this.fileLoader;
    if (v9153.type && v9153.type !== "arraybuffer") {
      throw new Error("THREE.GLTFLoader: " + v9153.type + " buffer type is not supported.");
    }
    if (v9153.uri === undefined && p11863 === 0) {
      return Promise.resolve(this.extensions[vO280.KHR_BINARY_GLTF].body);
    }
    const v9155 = this.options;
    return new Promise(function (p11864, p11865) {
      v9154.load(THREE.LoaderUtils.resolveURL(v9153.uri, v9155.path), p11864, undefined, function () {
        p11865(new Error("THREE.GLTFLoader: Failed to load buffer \"" + v9153.uri + "\"."));
      });
    });
  }
  loadBufferView(p11866) {
    const v9156 = this.json.bufferViews[p11866];
    return this.getDependency("buffer", v9156.buffer).then(function (p11867) {
      const v9157 = v9156.byteLength || 0;
      const v9158 = v9156.byteOffset || 0;
      return p11867.slice(v9158, v9158 + v9157);
    });
  }
  loadAccessor(p11868) {
    const vThis83 = this;
    const v9159 = this.json;
    const v9160 = this.json.accessors[p11868];
    if (v9160.bufferView === undefined && v9160.sparse === undefined) {
      const v9161 = vO290[v9160.type];
      const v9162 = vO287[v9160.componentType];
      const v9163 = v9160.normalized === true;
      const v9164 = new v9162(v9160.count * v9161);
      return Promise.resolve(new THREE.BufferAttribute(v9164, v9161, v9163));
    }
    const vA501 = [];
    if (v9160.bufferView !== undefined) {
      vA501.push(this.getDependency("bufferView", v9160.bufferView));
    } else {
      vA501.push(null);
    }
    if (v9160.sparse !== undefined) {
      vA501.push(this.getDependency("bufferView", v9160.sparse.indices.bufferView));
      vA501.push(this.getDependency("bufferView", v9160.sparse.values.bufferView));
    }
    return Promise.all(vA501).then(function (p11869) {
      const v9165 = p11869[0];
      const v9166 = vO290[v9160.type];
      const v9167 = vO287[v9160.componentType];
      const v9168 = v9167.BYTES_PER_ELEMENT;
      const v9169 = v9168 * v9166;
      const v9170 = v9160.byteOffset || 0;
      const v9171 = v9160.bufferView !== undefined ? v9159.bufferViews[v9160.bufferView].byteStride : undefined;
      const v9172 = v9160.normalized === true;
      let v9173;
      let v9174;
      if (v9171 && v9171 !== v9169) {
        const v9175 = Math.floor(v9170 / v9171);
        const v9176 = "InterleavedBuffer:" + v9160.bufferView + ":" + v9160.componentType + ":" + v9175 + ":" + v9160.count;
        let v9177 = vThis83.cache.get(v9176);
        if (!v9177) {
          v9173 = new v9167(v9165, v9175 * v9171, v9160.count * v9171 / v9168);
          v9177 = new THREE.InterleavedBuffer(v9173, v9171 / v9168);
          vThis83.cache.add(v9176, v9177);
        }
        v9174 = new THREE.InterleavedBufferAttribute(v9177, v9166, v9170 % v9171 / v9168, v9172);
      } else {
        if (v9165 === null) {
          v9173 = new v9167(v9160.count * v9166);
        } else {
          v9173 = new v9167(v9165, v9170, v9160.count * v9166);
        }
        v9174 = new THREE.BufferAttribute(v9173, v9166, v9172);
      }
      if (v9160.sparse !== undefined) {
        const v9178 = vO290.SCALAR;
        const v9179 = vO287[v9160.sparse.indices.componentType];
        const v9180 = v9160.sparse.indices.byteOffset || 0;
        const v9181 = v9160.sparse.values.byteOffset || 0;
        const v9182 = new v9179(p11869[1], v9180, v9160.sparse.count * v9178);
        const v9183 = new v9167(p11869[2], v9181, v9160.sparse.count * v9166);
        if (v9165 !== null) {
          v9174 = new THREE.BufferAttribute(v9174.array.slice(), v9174.itemSize, v9174.normalized);
        }
        for (let vLN01496 = 0, v9184 = v9182.length; vLN01496 < v9184; vLN01496++) {
          const v9185 = v9182[vLN01496];
          v9174.setX(v9185, v9183[vLN01496 * v9166]);
          if (v9166 >= 2) {
            v9174.setY(v9185, v9183[vLN01496 * v9166 + 1]);
          }
          if (v9166 >= 3) {
            v9174.setZ(v9185, v9183[vLN01496 * v9166 + 2]);
          }
          if (v9166 >= 4) {
            v9174.setW(v9185, v9183[vLN01496 * v9166 + 3]);
          }
          if (v9166 >= 5) {
            throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
          }
        }
      }
      return v9174;
    });
  }
  loadTexture(p11870) {
    const v9186 = this.json;
    const v9187 = this.options;
    const v9188 = v9186.textures[p11870];
    const v9189 = v9188.source;
    const v9190 = v9186.images[v9189];
    let v9191 = this.textureLoader;
    if (v9190.uri) {
      const v9192 = v9187.manager.getHandler(v9190.uri);
      if (v9192 !== null) {
        v9191 = v9192;
      }
    }
    return this.loadTextureImage(p11870, v9189, v9191);
  }
  loadTextureImage(p11871, p11872, p11873) {
    const vThis84 = this;
    const v9193 = this.json;
    const v9194 = v9193.textures[p11871];
    const v9195 = v9193.images[p11872];
    const v9196 = (v9195.uri || v9195.bufferView) + ":" + v9194.sampler;
    if (this.textureCache[v9196]) {
      return this.textureCache[v9196];
    }
    const v9197 = this.loadImageSource(p11872, p11873).then(function (p11874) {
      p11874.flipY = false;
      p11874.name = v9194.name || v9195.name || "";
      const v9198 = v9193.samplers || {};
      const v9199 = v9198[v9194.sampler] || {};
      p11874.magFilter = vO288[v9199.magFilter] || THREE.LinearFilter;
      p11874.minFilter = vO288[v9199.minFilter] || THREE.LinearMipmapLinearFilter;
      p11874.wrapS = vO289[v9199.wrapS] || THREE.RepeatWrapping;
      p11874.wrapT = vO289[v9199.wrapT] || THREE.RepeatWrapping;
      vThis84.associations.set(p11874, {
        textures: p11871
      });
      return p11874;
    }).catch(function () {
      return null;
    });
    this.textureCache[v9196] = v9197;
    return v9197;
  }
  loadImageSource(p11875, p11876) {
    const vThis85 = this;
    const v9200 = this.json;
    const v9201 = this.options;
    if (this.sourceCache[p11875] !== undefined) {
      return this.sourceCache[p11875].then(p11877 => p11877.clone());
    }
    const v9202 = v9200.images[p11875];
    const v9203 = self.URL || self.webkitURL;
    let v9204 = v9202.uri || "";
    let v9205 = false;
    if (v9202.bufferView !== undefined) {
      v9204 = vThis85.getDependency("bufferView", v9202.bufferView).then(function (p11878) {
        v9205 = true;
        const v9206 = new Blob([p11878], {
          type: v9202.mimeType
        });
        v9204 = v9203.createObjectURL(v9206);
        return v9204;
      });
    } else if (v9202.uri === undefined) {
      throw new Error("THREE.GLTFLoader: Image " + p11875 + " is missing URI and bufferView");
    }
    const v9207 = Promise.resolve(v9204).then(function (p11879) {
      return new Promise(function (p11880, p11881) {
        let vP11880 = p11880;
        if (p11876.isImageBitmapLoader === true) {
          vP11880 = function (p11882) {
            const v9208 = new THREE.Texture(p11882);
            v9208.needsUpdate = true;
            p11880(v9208);
          };
        }
        p11876.load(THREE.LoaderUtils.resolveURL(p11879, v9201.path), vP11880, undefined, p11881);
      });
    }).then(function (p11883) {
      if (v9205 === true) {
        v9203.revokeObjectURL(v9204);
      }
      p11883.userData.mimeType = v9202.mimeType || f1495(v9202.uri);
      return p11883;
    }).catch(function (p11884) {
      console.error("THREE.GLTFLoader: Couldn't load texture", v9204);
      throw p11884;
    });
    this.sourceCache[p11875] = v9207;
    return v9207;
  }
  assignTexture(p11885, p11886, p11887, p11888) {
    const vThis86 = this;
    return this.getDependency("texture", p11887.index).then(function (p11889) {
      if (!p11889) {
        return null;
      }
      if (p11887.texCoord !== undefined && p11887.texCoord != 0 && (p11886 !== "aoMap" || p11887.texCoord != 1)) {
        console.warn("THREE.GLTFLoader: Custom UV set " + p11887.texCoord + " for texture " + p11886 + " not yet supported.");
      }
      if (vThis86.extensions[vO280.KHR_TEXTURE_TRANSFORM]) {
        const v9209 = p11887.extensions !== undefined ? p11887.extensions[vO280.KHR_TEXTURE_TRANSFORM] : undefined;
        if (v9209) {
          const v9210 = vThis86.associations.get(p11889);
          p11889 = vThis86.extensions[vO280.KHR_TEXTURE_TRANSFORM].extendTexture(p11889, v9209);
          vThis86.associations.set(p11889, v9210);
        }
      }
      if (p11888 !== undefined) {
        p11889.encoding = p11888;
      }
      p11885[p11886] = p11889;
      return p11889;
    });
  }
  assignFinalMaterial(p11890) {
    const v9211 = p11890.geometry;
    let v9212 = p11890.material;
    const v9213 = v9211.attributes.tangent === undefined;
    const v9214 = v9211.attributes.color !== undefined;
    const v9215 = v9211.attributes.normal === undefined;
    if (p11890.isPoints) {
      const v9216 = "PointsMaterial:" + v9212.uuid;
      let v9217 = this.cache.get(v9216);
      if (!v9217) {
        v9217 = new THREE.PointsMaterial();
        THREE.Material.prototype.copy.call(v9217, v9212);
        v9217.color.copy(v9212.color);
        v9217.map = v9212.map;
        v9217.sizeAttenuation = false;
        this.cache.add(v9216, v9217);
      }
      v9212 = v9217;
    } else if (p11890.isLine) {
      const v9218 = "LineBasicMaterial:" + v9212.uuid;
      let v9219 = this.cache.get(v9218);
      if (!v9219) {
        v9219 = new THREE.LineBasicMaterial();
        THREE.Material.prototype.copy.call(v9219, v9212);
        v9219.color.copy(v9212.color);
        this.cache.add(v9218, v9219);
      }
      v9212 = v9219;
    }
    if (v9213 || v9214 || v9215) {
      let v9220 = "ClonedMaterial:" + v9212.uuid + ":";
      if (v9213) {
        v9220 += "derivative-tangents:";
      }
      if (v9214) {
        v9220 += "vertex-colors:";
      }
      if (v9215) {
        v9220 += "flat-shading:";
      }
      let v9221 = this.cache.get(v9220);
      if (!v9221) {
        v9221 = v9212.clone();
        if (v9214) {
          v9221.vertexColors = true;
        }
        if (v9215) {
          v9221.flatShading = true;
        }
        if (v9213) {
          if (v9221.normalScale) {
            v9221.normalScale.y *= -1;
          }
          if (v9221.clearcoatNormalScale) {
            v9221.clearcoatNormalScale.y *= -1;
          }
        }
        this.cache.add(v9220, v9221);
        this.associations.set(v9221, this.associations.get(v9212));
      }
      v9212 = v9221;
    }
    if (v9212.aoMap && v9211.attributes.uv2 === undefined && v9211.attributes.uv !== undefined) {
      v9211.setAttribute("uv2", v9211.attributes.uv);
    }
    p11890.material = v9212;
  }
  getMaterialType() {
    return THREE.MeshStandardMaterial;
  }
  loadMaterial(p11891) {
    const vThis87 = this;
    const v9222 = this.json;
    const v9223 = this.extensions;
    const v9224 = v9222.materials[p11891];
    let v9225;
    const vO296 = {};
    const v9226 = v9224.extensions || {};
    const vA502 = [];
    if (v9226[vO280.KHR_MATERIALS_UNLIT]) {
      const v9227 = v9223[vO280.KHR_MATERIALS_UNLIT];
      v9225 = v9227.getMaterialType();
      vA502.push(v9227.extendParams(vO296, v9224, vThis87));
    } else {
      const v9228 = v9224.pbrMetallicRoughness || {};
      vO296.color = new THREE.Color(1, 1, 1);
      vO296.opacity = 1;
      if (Array.isArray(v9228.baseColorFactor)) {
        const v9229 = v9228.baseColorFactor;
        vO296.color.fromArray(v9229);
        vO296.opacity = v9229[3];
      }
      if (v9228.baseColorTexture !== undefined) {
        vA502.push(vThis87.assignTexture(vO296, "map", v9228.baseColorTexture, THREE.sRGBEncoding));
      }
      vO296.metalness = v9228.metallicFactor !== undefined ? v9228.metallicFactor : 1;
      vO296.roughness = v9228.roughnessFactor !== undefined ? v9228.roughnessFactor : 1;
      if (v9228.metallicRoughnessTexture !== undefined) {
        vA502.push(vThis87.assignTexture(vO296, "metalnessMap", v9228.metallicRoughnessTexture));
        vA502.push(vThis87.assignTexture(vO296, "roughnessMap", v9228.metallicRoughnessTexture));
      }
      v9225 = this._invokeOne(function (p11892) {
        return p11892.getMaterialType && p11892.getMaterialType(p11891);
      });
      vA502.push(Promise.all(this._invokeAll(function (p11893) {
        return p11893.extendMaterialParams && p11893.extendMaterialParams(p11891, vO296);
      })));
    }
    if (v9224.doubleSided === true) {
      vO296.side = THREE.DoubleSide;
    }
    const v9230 = v9224.alphaMode || vO294.OPAQUE;
    if (v9230 === vO294.BLEND) {
      vO296.transparent = true;
      vO296.depthWrite = false;
    } else {
      vO296.transparent = false;
      if (v9230 === vO294.MASK) {
        vO296.alphaTest = v9224.alphaCutoff !== undefined ? v9224.alphaCutoff : 0.5;
      }
    }
    if (v9224.normalTexture !== undefined && v9225 !== THREE.MeshBasicMaterial) {
      vA502.push(vThis87.assignTexture(vO296, "normalMap", v9224.normalTexture));
      vO296.normalScale = new THREE.Vector2(1, 1);
      if (v9224.normalTexture.scale !== undefined) {
        const v9231 = v9224.normalTexture.scale;
        vO296.normalScale.set(v9231, v9231);
      }
    }
    if (v9224.occlusionTexture !== undefined && v9225 !== THREE.MeshBasicMaterial) {
      vA502.push(vThis87.assignTexture(vO296, "aoMap", v9224.occlusionTexture));
      if (v9224.occlusionTexture.strength !== undefined) {
        vO296.aoMapIntensity = v9224.occlusionTexture.strength;
      }
    }
    if (v9224.emissiveFactor !== undefined && v9225 !== THREE.MeshBasicMaterial) {
      vO296.emissive = new THREE.Color().fromArray(v9224.emissiveFactor);
    }
    if (v9224.emissiveTexture !== undefined && v9225 !== THREE.MeshBasicMaterial) {
      vA502.push(vThis87.assignTexture(vO296, "emissiveMap", v9224.emissiveTexture, THREE.sRGBEncoding));
    }
    return Promise.all(vA502).then(function () {
      const v9232 = new v9225(vO296);
      if (v9224.name) {
        v9232.name = v9224.name;
      }
      f1489(v9232, v9224);
      vThis87.associations.set(v9232, {
        materials: p11891
      });
      if (v9224.extensions) {
        f1488(v9223, v9232, v9224);
      }
      return v9232;
    });
  }
  createUniqueName(p11894) {
    const v9233 = THREE.PropertyBinding.sanitizeNodeName(p11894 || "");
    let vV9233 = v9233;
    for (let vLN1139 = 1; this.nodeNamesUsed[vV9233]; ++vLN1139) {
      vV9233 = v9233 + "_" + vLN1139;
    }
    this.nodeNamesUsed[vV9233] = true;
    return vV9233;
  }
  loadGeometries(p11895) {
    const vThis88 = this;
    const v9234 = this.extensions;
    const v9235 = this.primitiveCache;
    function f1496(p11896) {
      return v9234[vO280.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(p11896, vThis88).then(function (p11897) {
        return f1499(p11897, p11896, vThis88);
      });
    }
    const vA503 = [];
    for (let vLN01497 = 0, v9236 = p11895.length; vLN01497 < v9236; vLN01497++) {
      const v9237 = p11895[vLN01497];
      const vF1492 = f1492(v9237);
      const v9238 = v9235[vF1492];
      if (v9238) {
        vA503.push(v9238.promise);
      } else {
        let v9239;
        if (v9237.extensions && v9237.extensions[vO280.KHR_DRACO_MESH_COMPRESSION]) {
          v9239 = f1496(v9237);
        } else {
          v9239 = f1499(new THREE.BufferGeometry(), v9237, vThis88);
        }
        v9235[vF1492] = {
          primitive: v9237,
          promise: v9239
        };
        vA503.push(v9239);
      }
    }
    return Promise.all(vA503);
  }
  loadMesh(p11898) {
    const vThis89 = this;
    const v9240 = this.json;
    const v9241 = this.extensions;
    const v9242 = v9240.meshes[p11898];
    const v9243 = v9242.primitives;
    const vA504 = [];
    for (let vLN01498 = 0, v9244 = v9243.length; vLN01498 < v9244; vLN01498++) {
      const v9245 = v9243[vLN01498].material === undefined ? f1487(this.cache) : this.getDependency("material", v9243[vLN01498].material);
      vA504.push(v9245);
    }
    vA504.push(vThis89.loadGeometries(v9243));
    return Promise.all(vA504).then(function (p11899) {
      const v9246 = p11899.slice(0, p11899.length - 1);
      const v9247 = p11899[p11899.length - 1];
      const vA505 = [];
      for (let vLN01499 = 0, v9248 = v9247.length; vLN01499 < v9248; vLN01499++) {
        const v9249 = v9247[vLN01499];
        const v9250 = v9243[vLN01499];
        let v9251;
        const v9252 = v9246[vLN01499];
        if (v9250.mode === vO286.TRIANGLES || v9250.mode === vO286.TRIANGLE_STRIP || v9250.mode === vO286.TRIANGLE_FAN || v9250.mode === undefined) {
          v9251 = v9242.isSkinnedMesh === true ? new THREE.SkinnedMesh(v9249, v9252) : new THREE.Mesh(v9249, v9252);
          if (v9251.isSkinnedMesh === true) {
            v9251.normalizeSkinWeights();
          }
          if (v9250.mode === vO286.TRIANGLE_STRIP) {
            v9251.geometry = f1480(v9251.geometry, THREE.TriangleStripDrawMode);
          } else if (v9250.mode === vO286.TRIANGLE_FAN) {
            v9251.geometry = f1480(v9251.geometry, THREE.TriangleFanDrawMode);
          }
        } else if (v9250.mode === vO286.LINES) {
          v9251 = new THREE.LineSegments(v9249, v9252);
        } else if (v9250.mode === vO286.LINE_STRIP) {
          v9251 = new THREE.Line(v9249, v9252);
        } else if (v9250.mode === vO286.LINE_LOOP) {
          v9251 = new THREE.LineLoop(v9249, v9252);
        } else if (v9250.mode === vO286.POINTS) {
          v9251 = new THREE.Points(v9249, v9252);
        } else {
          throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + v9250.mode);
        }
        if (Object.keys(v9251.geometry.morphAttributes).length > 0) {
          f1491(v9251, v9242);
        }
        v9251.name = vThis89.createUniqueName(v9242.name || "mesh_" + p11898);
        f1489(v9251, v9242);
        if (v9250.extensions) {
          f1488(v9241, v9251, v9250);
        }
        vThis89.assignFinalMaterial(v9251);
        vA505.push(v9251);
      }
      for (let vLN01500 = 0, v9253 = vA505.length; vLN01500 < v9253; vLN01500++) {
        vThis89.associations.set(vA505[vLN01500], {
          meshes: p11898,
          primitives: vLN01500
        });
      }
      if (vA505.length === 1) {
        return vA505[0];
      }
      const v9254 = new THREE.Group();
      vThis89.associations.set(v9254, {
        meshes: p11898
      });
      for (let vLN01501 = 0, v9255 = vA505.length; vLN01501 < v9255; vLN01501++) {
        v9254.add(vA505[vLN01501]);
      }
      return v9254;
    });
  }
  loadCamera(p11900) {
    let v9256;
    const v9257 = this.json.cameras[p11900];
    const v9258 = v9257[v9257.type];
    if (!v9258) {
      console.warn("THREE.GLTFLoader: Missing camera parameters.");
      return;
    }
    if (v9257.type === "perspective") {
      v9256 = new THREE.PerspectiveCamera(THREE.MathUtils.radToDeg(v9258.yfov), v9258.aspectRatio || 1, v9258.znear || 1, v9258.zfar || 2000000);
    } else if (v9257.type === "orthographic") {
      v9256 = new THREE.OrthographicCamera(-v9258.xmag, v9258.xmag, v9258.ymag, -v9258.ymag, v9258.znear, v9258.zfar);
    }
    if (v9257.name) {
      v9256.name = this.createUniqueName(v9257.name);
    }
    f1489(v9256, v9257);
    return Promise.resolve(v9256);
  }
  loadSkin(p11901) {
    const v9259 = this.json.skins[p11901];
    const vA506 = [];
    for (let vLN01502 = 0, v9260 = v9259.joints.length; vLN01502 < v9260; vLN01502++) {
      vA506.push(this._loadNodeShallow(v9259.joints[vLN01502]));
    }
    if (v9259.inverseBindMatrices !== undefined) {
      vA506.push(this.getDependency("accessor", v9259.inverseBindMatrices));
    } else {
      vA506.push(null);
    }
    return Promise.all(vA506).then(function (p11902) {
      const v9261 = p11902.pop();
      const vP11902 = p11902;
      const vA507 = [];
      const vA508 = [];
      for (let vLN01503 = 0, v9262 = vP11902.length; vLN01503 < v9262; vLN01503++) {
        const v9263 = vP11902[vLN01503];
        if (v9263) {
          vA507.push(v9263);
          const v9264 = new THREE.Matrix4();
          if (v9261 !== null) {
            v9264.fromArray(v9261.array, vLN01503 * 16);
          }
          vA508.push(v9264);
        } else {
          console.warn("THREE.GLTFLoader: Joint \"%s\" could not be found.", v9259.joints[vLN01503]);
        }
      }
      return new THREE.Skeleton(vA507, vA508);
    });
  }
  loadAnimation(p11903) {
    const v9265 = this.json;
    const v9266 = v9265.animations[p11903];
    const vA509 = [];
    const vA510 = [];
    const vA511 = [];
    const vA512 = [];
    const vA513 = [];
    for (let vLN01504 = 0, v9267 = v9266.channels.length; vLN01504 < v9267; vLN01504++) {
      const v9268 = v9266.channels[vLN01504];
      const v9269 = v9266.samplers[v9268.sampler];
      const v9270 = v9268.target;
      const v9271 = v9270.node;
      const v9272 = v9266.parameters !== undefined ? v9266.parameters[v9269.input] : v9269.input;
      const v9273 = v9266.parameters !== undefined ? v9266.parameters[v9269.output] : v9269.output;
      vA509.push(this.getDependency("node", v9271));
      vA510.push(this.getDependency("accessor", v9272));
      vA511.push(this.getDependency("accessor", v9273));
      vA512.push(v9269);
      vA513.push(v9270);
    }
    return Promise.all([Promise.all(vA509), Promise.all(vA510), Promise.all(vA511), Promise.all(vA512), Promise.all(vA513)]).then(function (p11904) {
      const v9274 = p11904[0];
      const v9275 = p11904[1];
      const v9276 = p11904[2];
      const v9277 = p11904[3];
      const v9278 = p11904[4];
      const vA514 = [];
      for (let vLN01505 = 0, v9279 = v9274.length; vLN01505 < v9279; vLN01505++) {
        const v9280 = v9274[vLN01505];
        const v9281 = v9275[vLN01505];
        const v9282 = v9276[vLN01505];
        const v9283 = v9277[vLN01505];
        const v9284 = v9278[vLN01505];
        if (v9280 === undefined) {
          continue;
        }
        v9280.updateMatrix();
        let v9285;
        switch (vO292[v9284.path]) {
          case vO292.weights:
            v9285 = THREE.NumberKeyframeTrack;
            break;
          case vO292.rotation:
            v9285 = THREE.QuaternionKeyframeTrack;
            break;
          case vO292.position:
          case vO292.scale:
          default:
            v9285 = THREE.VectorKeyframeTrack;
            break;
        }
        const v9286 = v9280.name ? v9280.name : v9280.uuid;
        const v9287 = v9283.interpolation !== undefined ? vO293[v9283.interpolation] : THREE.InterpolateLinear;
        const vA515 = [];
        if (vO292[v9284.path] === vO292.weights) {
          v9280.traverse(function (p11905) {
            if (p11905.morphTargetInfluences) {
              vA515.push(p11905.name ? p11905.name : p11905.uuid);
            }
          });
        } else {
          vA515.push(v9286);
        }
        let v9288 = v9282.array;
        if (v9282.normalized) {
          const vF1494 = f1494(v9288.constructor);
          const v9289 = new Float32Array(v9288.length);
          for (let vLN01506 = 0, v9290 = v9288.length; vLN01506 < v9290; vLN01506++) {
            v9289[vLN01506] = v9288[vLN01506] * vF1494;
          }
          v9288 = v9289;
        }
        for (let vLN01507 = 0, v9291 = vA515.length; vLN01507 < v9291; vLN01507++) {
          const v9292 = new v9285(vA515[vLN01507] + "." + vO292[v9284.path], v9281.array, v9288, v9287);
          if (v9283.interpolation === "CUBICSPLINE") {
            v9292.createInterpolant = function f1497(p11906) {
              const v9293 = this instanceof THREE.QuaternionKeyframeTrack ? C276 : C275;
              return new v9293(this.times, this.values, this.getValueSize() / 3, p11906);
            };
            v9292.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
          }
          vA514.push(v9292);
        }
      }
      const v9294 = v9266.name ? v9266.name : "animation_" + p11903;
      return new THREE.AnimationClip(v9294, undefined, vA514);
    });
  }
  createNodeMesh(p11907) {
    const v9295 = this.json;
    const vThis90 = this;
    const v9296 = v9295.nodes[p11907];
    if (v9296.mesh === undefined) {
      return null;
    }
    return vThis90.getDependency("mesh", v9296.mesh).then(function (p11908) {
      const v9297 = vThis90._getNodeRef(vThis90.meshCache, v9296.mesh, p11908);
      if (v9296.weights !== undefined) {
        v9297.traverse(function (p11909) {
          if (!p11909.isMesh) {
            return;
          }
          for (let vLN01508 = 0, v9298 = v9296.weights.length; vLN01508 < v9298; vLN01508++) {
            p11909.morphTargetInfluences[vLN01508] = v9296.weights[vLN01508];
          }
        });
      }
      return v9297;
    });
  }
  loadNode(p11910) {
    const v9299 = this.json;
    const vThis91 = this;
    const v9300 = v9299.nodes[p11910];
    const v9301 = vThis91._loadNodeShallow(p11910);
    const vA516 = [];
    const v9302 = v9300.children || [];
    for (let vLN01509 = 0, v9303 = v9302.length; vLN01509 < v9303; vLN01509++) {
      vA516.push(vThis91.getDependency("node", v9302[vLN01509]));
    }
    const v9304 = v9300.skin === undefined ? Promise.resolve(null) : vThis91.getDependency("skin", v9300.skin);
    return Promise.all([v9301, Promise.all(vA516), v9304]).then(function (p11911) {
      const v9305 = p11911[0];
      const v9306 = p11911[1];
      const v9307 = p11911[2];
      if (v9307 !== null) {
        v9305.traverse(function (p11912) {
          if (!p11912.isSkinnedMesh) {
            return;
          }
          p11912.bind(v9307, v9129);
        });
      }
      for (let vLN01510 = 0, v9308 = v9306.length; vLN01510 < v9308; vLN01510++) {
        v9305.add(v9306[vLN01510]);
      }
      return v9305;
    });
  }
  _loadNodeShallow(p11913) {
    const v9309 = this.json;
    const v9310 = this.extensions;
    const vThis92 = this;
    if (this.nodeCache[p11913] !== undefined) {
      return this.nodeCache[p11913];
    }
    const v9311 = v9309.nodes[p11913];
    const v9312 = v9311.name ? vThis92.createUniqueName(v9311.name) : "";
    const vA517 = [];
    const v9313 = vThis92._invokeOne(function (p11914) {
      return p11914.createNodeMesh && p11914.createNodeMesh(p11913);
    });
    if (v9313) {
      vA517.push(v9313);
    }
    if (v9311.camera !== undefined) {
      vA517.push(vThis92.getDependency("camera", v9311.camera).then(function (p11915) {
        return vThis92._getNodeRef(vThis92.cameraCache, v9311.camera, p11915);
      }));
    }
    vThis92._invokeAll(function (p11916) {
      return p11916.createNodeAttachment && p11916.createNodeAttachment(p11913);
    }).forEach(function (p11917) {
      vA517.push(p11917);
    });
    this.nodeCache[p11913] = Promise.all(vA517).then(function (p11918) {
      let v9314;
      if (v9311.isBone === true) {
        v9314 = new THREE.Bone();
      } else if (p11918.length > 1) {
        v9314 = new THREE.Group();
      } else if (p11918.length === 1) {
        v9314 = p11918[0];
      } else {
        v9314 = new THREE.Object3D();
      }
      if (v9314 !== p11918[0]) {
        for (let vLN01511 = 0, v9315 = p11918.length; vLN01511 < v9315; vLN01511++) {
          v9314.add(p11918[vLN01511]);
        }
      }
      if (v9311.name) {
        v9314.userData.name = v9311.name;
        v9314.name = v9312;
      }
      f1489(v9314, v9311);
      if (v9311.extensions) {
        f1488(v9310, v9314, v9311);
      }
      if (v9311.matrix !== undefined) {
        const v9316 = new THREE.Matrix4();
        v9316.fromArray(v9311.matrix);
        v9314.applyMatrix4(v9316);
      } else {
        if (v9311.translation !== undefined) {
          v9314.position.fromArray(v9311.translation);
        }
        if (v9311.rotation !== undefined) {
          v9314.quaternion.fromArray(v9311.rotation);
        }
        if (v9311.scale !== undefined) {
          v9314.scale.fromArray(v9311.scale);
        }
      }
      if (!vThis92.associations.has(v9314)) {
        vThis92.associations.set(v9314, {});
      }
      vThis92.associations.get(v9314).nodes = p11913;
      return v9314;
    });
    return this.nodeCache[p11913];
  }
  loadScene(p11919) {
    const v9317 = this.extensions;
    const v9318 = this.json.scenes[p11919];
    const vThis93 = this;
    const v9319 = new THREE.Group();
    if (v9318.name) {
      v9319.name = vThis93.createUniqueName(v9318.name);
    }
    f1489(v9319, v9318);
    if (v9318.extensions) {
      f1488(v9317, v9319, v9318);
    }
    const v9320 = v9318.nodes || [];
    const vA518 = [];
    for (let vLN01512 = 0, v9321 = v9320.length; vLN01512 < v9321; vLN01512++) {
      vA518.push(vThis93.getDependency("node", v9320[vLN01512]));
    }
    return Promise.all(vA518).then(function (p11920) {
      for (let vLN01513 = 0, v9322 = p11920.length; vLN01513 < v9322; vLN01513++) {
        v9319.add(p11920[vLN01513]);
      }
      const vF82 = p11921 => {
        const v9323 = new Map();
        for (const [v9324, v9325] of vThis93.associations) {
          if (v9324 instanceof THREE.Material || v9324 instanceof THREE.Texture) {
            v9323.set(v9324, v9325);
          }
        }
        p11921.traverse(p11922 => {
          const v9326 = vThis93.associations.get(p11922);
          if (v9326 != null) {
            v9323.set(p11922, v9326);
          }
        });
        return v9323;
      };
      vThis93.associations = vF82(v9319);
      return v9319;
    });
  }
}
function f1498(p11923, p11924, p11925) {
  const v9327 = p11924.attributes;
  const v9328 = new THREE.Box3();
  if (v9327.POSITION !== undefined) {
    const v9329 = p11925.json.accessors[v9327.POSITION];
    const v9330 = v9329.min;
    const v9331 = v9329.max;
    if (v9330 !== undefined && v9331 !== undefined) {
      v9328.set(new THREE.Vector3(v9330[0], v9330[1], v9330[2]), new THREE.Vector3(v9331[0], v9331[1], v9331[2]));
      if (v9329.normalized) {
        const vF14942 = f1494(vO287[v9329.componentType]);
        v9328.min.multiplyScalar(vF14942);
        v9328.max.multiplyScalar(vF14942);
      }
    } else {
      console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      return;
    }
  } else {
    return;
  }
  const v9332 = p11924.targets;
  if (v9332 !== undefined) {
    const v9333 = new THREE.Vector3();
    const v9334 = new THREE.Vector3();
    for (let vLN01514 = 0, v9335 = v9332.length; vLN01514 < v9335; vLN01514++) {
      const v9336 = v9332[vLN01514];
      if (v9336.POSITION !== undefined) {
        const v9337 = p11925.json.accessors[v9336.POSITION];
        const v9338 = v9337.min;
        const v9339 = v9337.max;
        if (v9338 !== undefined && v9339 !== undefined) {
          v9334.setX(Math.max(Math.abs(v9338[0]), Math.abs(v9339[0])));
          v9334.setY(Math.max(Math.abs(v9338[1]), Math.abs(v9339[1])));
          v9334.setZ(Math.max(Math.abs(v9338[2]), Math.abs(v9339[2])));
          if (v9337.normalized) {
            const vF14943 = f1494(vO287[v9337.componentType]);
            v9334.multiplyScalar(vF14943);
          }
          v9333.max(v9334);
        } else {
          console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
        }
      }
    }
    v9328.expandByVector(v9333);
  }
  p11923.boundingBox = v9328;
  const v9340 = new THREE.Sphere();
  v9328.getCenter(v9340.center);
  v9340.radius = v9328.min.distanceTo(v9328.max) / 2;
  p11923.boundingSphere = v9340;
}
function f1499(p11926, p11927, p11928) {
  const v9341 = p11927.attributes;
  const vA519 = [];
  function f1500(p11929, p11930) {
    return p11928.getDependency("accessor", p11929).then(function (p11931) {
      p11926.setAttribute(p11930, p11931);
    });
  }
  for (const v9342 in v9341) {
    const v9343 = vO291[v9342] || v9342.toLowerCase();
    if (v9343 in p11926.attributes) {
      continue;
    }
    vA519.push(f1500(v9341[v9342], v9343));
  }
  if (p11927.indices !== undefined && !p11926.index) {
    const v9344 = p11928.getDependency("accessor", p11927.indices).then(function (p11932) {
      p11926.setIndex(p11932);
    });
    vA519.push(v9344);
  }
  f1489(p11926, p11927);
  f1498(p11926, p11927, p11928);
  return Promise.all(vA519).then(function () {
    if (p11927.targets !== undefined) {
      return f1490(p11926, p11927.targets, p11928);
    } else {
      return p11926;
    }
  });
}